import { Component, ViewChild } from "@angular/core";
import { Observable, of, Subject } from "rxjs";
import {
  AgencyMasterProperties,
  AgencyBaseDataProperties,
  ReportTypesAgency,
  ReportTypesUser,
  CustomerCodes,
  UrlRequest,
  CreditLimitChecking,
  SupplierRightsForAgencyAndBranchProperties,
  SuppliersOfficeIds,
  SupplierRightsForAgencyAndBranchBooleanProperties,
} from "../Models/AgencyMasterProperties";
import {
  B2BActiveBranches, CustomerSaleOrder, ActiveBranches, ActiveAgencies,
  ActiveCurrencies, ActiveLanguages, Agency_Branches, ParentUsers
} from "../Models/ActiveClasses";
import { BranchService } from "../Services/branch.service";
import { ManagerProperties } from "../Models/ManagerProperties";
import { BackSystemAllList, BackSystemCompanyId, BackSystemOfficeProperties, BranchInformationProperties, ParentBackSystemCompanies } from "../models/BranchInformationProperties";
import { Router } from "@angular/router";
import { UserAdminControlRightsProperties, UserAgentRightsProperties, UserRightsDisabledProperties, UsersProperties } from "../Models/UsersProperties";
import { AgencySupplierRightsdata, AgencySupplierRightsList } from "../Models/SuppliersProperties";
import { AgencyRightsProperties, ReportAgencyRightsProperties } from "../Models/AgencyRightsProperties";
import { NgSelectComponent } from "@ng-select/ng-select";
import { Countries } from "../Models/Countries";
import { CompanyMasterProperties } from "../Models/CompanyMasterProperties";
import { environment } from "../../environments/environment";
import { HttpClient, HttpRequest, HttpEventType, HttpResponse } from '@angular/common/http';


declare var $;

@Component({
  selector: 'app-branch-information',
  templateUrl: './branch-information.component.html',
  styleUrls: ['./branch-information.component.css']
})
/** BranchInformation component*/
export class BranchInformationComponent {
  immediateParentForuser: string;
  agencylistid: string;
  branchColor = "hsl(40,100%,50%)";
  /** branchMaster ctor */
  constructor(private branchService: BranchService, private router: Router, private http: HttpClient) { }
  branchObj = new BranchInformationProperties();
  userRightDisable = new UserRightsDisabledProperties();
  supplierRightsData = new AgencySupplierRightsdata();
  customerCodeList$: Observable<CustomerSaleOrder[]>;
  branchCodeList$: Observable<B2BActiveBranches[]>;
  backSystemBranchCodeList$: Observable<ActiveBranches[]>;
  agencyCodeList$: Observable<Agency_Branches[]>;
  currencyCodeList$: Observable<ActiveCurrencies[]>;
  languageCodeList$: Observable<ActiveLanguages[]>;
  managerUserList$: Observable<ParentUsers[]>;
  managerList: ManagerProperties[] = [];
  parentUsertList: ParentUsers[] = [];
  allBaseData$: AgencyBaseDataProperties;
  backsystemOfficeProperties: BackSystemOfficeProperties[] = [];
  branchInfoComplete = true;
  BackOfficeInfoComplete = false;
  managerInfoComplete = false;
  adminInfoComplete = false;
  settleModeComplete = false;
  logoInfoComplete = false;
  agencyRightsComplete = false;
  supplierRightsComplete = false;
  supplierStep = false;
  stepOne = true;
  stepTwo = false;
  stepThree = false;
  stepFour = false;
  stepFive = false;
  stepSix = false;
  stepSeven = false;
  settelementCash = false;
  settelementCredit = true;
  creditReadOnly = true;
  isAgency = false;
  creditCheck = false;
  creationBranch = "";
  agencyBlock = false;
  immediateParentBlock = false;
  checkImgUpload = false;
  disablefileupload: boolean = false;
  baseUrl = environment.baseUrl;
  imageSource: any;
  public progress: number;
  countryList: Countries[] = [];
  /** Branch Rights Disabled */
  agr_profileDisabled = false;
  agr_BeneficiaryDisabled = false;
  agr_PaymentDisabled = false;
  agr_CreditDisabled = false;
  agr_NoticationsDisabled = false;
  agr_ServiceFeeDisabled = false;
  agr_OfflineRequestDisabled = false;
  agr_OfflineSettingsDisabled = false;
  agr_SupplierDisabled = false;
  agr_AccountManagementDisabled = false;
  agr_BookingsDisabled = false;
  agr_CmsDisabled = false;
  agr_ReportsDisabled = false;
  agr_DashboardDisabled = false;
  agr_AddPaymentDisabled = false;
  agr_ApprovePaymentDisabled = false;
  agr_DeletePaymentDisabled = false;
  agr_AccountDisabled = false;
  agr_UsersDisabled = false;
  agr_LogsDisabled = false;
  agr_CurrencyDisabled = false;
  agr_SearchBookingsDisabled = false;
  agr_ViewBookingsDisabled = false;
  agr_UpdateBookingsDisabled = false;
  reportTypesAgency: ReportTypesAgency[] = [];
  reportTypesUser: ReportTypesUser[] = [];
  reportRights: ReportAgencyRightsProperties[] = [];
  branchTypes = [
    { value: 1, type: "Independent travel agents" },
    { value: 2, type: "Multiple travel agents" },
    { value: 3, type: "Miniple travel agents" },
  ];
  branchLanguage = [
    { value: 1, type: "Urdu" },
    { value: 2, type: "English" },
    { value: 3, type: "Arbi" },
  ];
  branchGroup = [
    { type: "" },
    { type: "" },
    { type: "" },
  ];
  currency = [
    { value: 1, type: "Dirham د.إ" },
    { value: 2, type: "Doller $" },
    { value: 3, type: "PKR Rs" },
  ];
  codes: CustomerCodes[] = [];
  loaderVar: boolean = false;
  backSystemAllList: BackSystemAllList[] = [];
  backSystemCompanyIds: BackSystemCompanyId[] = [];
  onChnageCode: CustomerCodes[] = [];
  @ViewChild('CustCodes', { static: false }) custCode: NgSelectComponent;
  userlimitreached: boolean = false;
  userLimitNumber: number = 0;
  AgencyBranchLimitationRights: boolean;
  agencyAG01: string = "";
  AgencyBranchChildLimitationRights: boolean;
  parentManagerList: ParentUsers[] = [];
  ParentManagerValidationBool = false;
  creditLimitChecking = new CreditLimitChecking();
  pendingCreditDecreased = false;
  pendingCreditChange: number = 0;
  backSystemCompanies: CompanyMasterProperties[] = [];
  backSystemCompaniesForAdminInfo: CompanyMasterProperties[] = [];
  agencySuppliers: SupplierRightsForAgencyAndBranchProperties[] = [];
  backSystemCompanyDisabeld: boolean = false;
  selectMultipleBackSystemCustomer: boolean = false;
  insuranceSuppliers: SupplierRightsForAgencyAndBranchProperties[] = [];
  backsystemParentCompanies = new ParentBackSystemCompanies();
  ngOnInit() {
    this.agencylistid = (localStorage.getItem("BranchListId"));
    this.getReportTypes();
    this.GetbranchBaseData();
    this.AddManager();
    this.getCountries();
    this.agencyAG01 = localStorage.getItem("AgencyId");
    this.GetBackSystemCompanies();
    this.imageSource = 'assets/img/Group 430.svg';



  }
  GetBackSystemCompanies() {
    this.branchService.GetCompanyMaster().subscribe(data => {
      this.backSystemCompanies = data;
    })

  }

  GetChildAgencyRight(agencyId) {
    this.branchService.AgencyBranchChildLimitationRights(agencyId).subscribe((data) => {
      this.AgencyBranchChildLimitationRights = data;
    });

  }
  GetParentManagers(param, agencyId) {
    let isAgency: Boolean = false;
    this.branchService.GetUsersByParent(param, isAgency, agencyId).subscribe((data) => {
      this.parentManagerList = data
    })
  }
  ParentManagerValidation() {
    if (this.parentManagerList.length > 0) {
      for (let i = 0; i < this.parentManagerList.length; i++) {
        for (let j = 0; j < this.branchObj.managers.length; j++) {
          if (this.branchObj.managers[j].userId == this.parentManagerList[i].userId) {
            this.ParentManagerValidationBool = true;
            break;
          }
          else {
            this.ParentManagerValidationBool = false;
          }
        }
        if (this.ParentManagerValidationBool) {
          break;
        }
      }
    }
    return this.ParentManagerValidationBool;
  }
  getCountries() {
    try {
      this.branchService.getCountries().subscribe((data) => {
        this.countryList = data;

      });
    }
    catch (e) {
      console.log(e);
    }
  }

  GetbranchBaseData() {
    try {
      //---------------------------------- This Section Is Just Updated To Test Parent Baranch Data ------------------------------//
      // 25-05-23 changes Commenet for Testing...............
      //let agencyId = "", loginAgency = "", treeBranchParent, treeSelectedValue = "";
      //end...........

      this.branchService.GetBackSystemBranches().subscribe((data) => {
        this.backSystemBranchCodeList$ = of(data);
      });
      //25-05-23 changes  new Updated For Testing...........
      let branchId = "", loginAgency = "", branchParent, immediateBranchParent = "";


      if ((localStorage.getItem("AgencyId") != undefined) && (localStorage.getItem("AgencyId") != "")) {
        branchParent = localStorage.getItem("AgencyId");
        if (branchParent.includes("B")) {
          immediateBranchParent = localStorage.getItem("ImmediateParent")
          this.branchService.GetParentChildBranches(immediateBranchParent).subscribe((result) => {
            //console.log(result)
            this.branchCodeList$ = of(result);
            if (result.length > 0) {
              let bId = "";
              for (let i = 0; i < result.length; i++) {
                bId = result[0].branchId;
                // 25-05-23 changes new procedure Also Created GetAgencyBaseDataForBranch
                this.branchService.GetAgencyBaseDataForBranch(bId).subscribe((result) => {
                  this.agencyCodeList$ = of(result);

                });

              }
            }
          });
        }
        //  end





        //25-05-23 changes .......Old Commented  for testing
        //treeSelectedValue = localStorage.getItem("Branch_TreeSelectedValue");
        //if (treeSelectedValue != undefined && treeSelectedValue != "" && treeSelectedValue != null) {
        //  treeBranchParent = localStorage.getItem("Branch_TreeBranchParent");
        //  if (treeBranchParent != "" && treeBranchParent != null && treeBranchParent != undefined) {
        //    loginAgency = treeBranchParent;
        //    this.branchObj.immediateParent = treeSelectedValue;
        //    this.branchObj.agencyId = treeBranchParent;

        //    this.branchService.GetParentChildBranches(this.branchObj.agencyId).subscribe((data) => {
        //      if (data.some(e => e.branchId === treeSelectedValue)) {
        //        this.branchCodeList$ = of(data);
        //      }
        //      else {
        //        this.branchService.GetParentChildBranches(this.branchObj.immediateParent).subscribe((result) => {
        //          this.branchCodeList$ = of(result);
        //        });
        //      }
        //    })
        //  }

        //  else {
        //    loginAgency = treeSelectedValue;
        //    this.branchObj.agencyId = treeSelectedValue;
        //  }
        //}
        //else if ((localStorage.getItem("AgencyId") != undefined) && (localStorage.getItem("AgencyId") != ""))
        //---------------------------------- Section End ------------------------------//
        loginAgency = localStorage.getItem("AgencyId");
        localStorage.removeItem("Branch_TreeSelectedValue");
        localStorage.removeItem("Branch_TreeBranchParent");
        this.branchService.GetBaseDataForAgencyMaster(loginAgency).subscribe((data) => {
          this.allBaseData$ = data;
          this.agencyCodeList$ = of(this.allBaseData$.agencies);
          this.currencyCodeList$ = of(this.allBaseData$.currencies);
          this.languageCodeList$ = of(this.allBaseData$.languages);


          if ((localStorage.getItem("BranchListId") != undefined) && (localStorage.getItem("BranchListId") != "")) {
            branchId = (localStorage.getItem("BranchListId"));
            localStorage.removeItem("BranchListId");
            this.branchService.GetBranchById(branchId).subscribe((data) => {
              this.immediateParentForuser = "";
              this.immediateParentForuser = data.immediateParent;
              this.pendingCreditChange = data.creditLimit;
              this.branchObj = data;
              this.GetChildAgencyRight(this.branchObj.agencyId)
              this.userLimitNumber = this.branchObj.maxUsers;
              this.reportRights = this.branchObj.agencyRightObj.reportRights;

              for (let i = 0; i < this.reportRights.length; i++) {

                for (let j = 0; j < this.reportTypesAgency.length; j++) {
                  if (this.reportRights[i].reportTypeName == this.reportTypesAgency[j].reportTypes) {
                    this.reportTypesAgency[j].status = this.reportRights[i].status;
                    this.reportTypesAgency[j].reportRightId = this.reportRights[i].reportAgencyRightId;

                  }

                }
              }
              if (this.branchObj != undefined && this.branchObj != null) {
                if (this.branchObj.backCompanyId != null && this.branchObj.backCompanyId != undefined && this.branchObj.backCompanyId > 0) {
                  this.backSystemCompanyDisabeld = true;
                }
                else {
                  this.backSystemCompanyDisabeld = false;
                }
                this.agencyBlock = true;
                this.immediateParentBlock = true;
                if ((this.branchObj.userObj.firstName == null &&
                  this.branchObj.userObj.lastName == null) ||
                  this.branchObj.userObj.loginName == null) {

                  this.branchObj.userObj = new UsersProperties();
                }
                if (this.branchObj.managers.length > 0)

                  this.managerList = this.branchObj.managers;
                if (this.branchObj.settlementMode == 1) {
                  //  this.settelementCash = true;
                  // this.creditReadOnly = false;
                  this.settelementCash = true;
                  this.creditReadOnly = false;
                  this.settelementCredit = false;
                }
                else if (this.branchObj.settlementMode == 2) {
                  // this.settelementCredit = true;
                  // this.creditReadOnly = false;
                  this.settelementCredit = true;
                  this.creditReadOnly = true;
                  this.settelementCash = false;
                }
                else {
                  // this.settelementCash = false;
                  // this.settelementCredit = false;
                  // this.creditReadOnly = true;
                  this.settelementCash = false;
                  this.settelementCredit = false;
                  this.creditReadOnly = true;

                }
                if (this.branchObj.imageFile != "" && this.branchObj.imageFile != null) {
                  this.imageSource = 'data:image/jpg;base64,' + this.branchObj.imageFile;
                  this.checkImgUpload = true;
                }
                else {
                  this.imageSource = 'assets/img/Group 430.svg';
                  this.checkImgUpload = false;
                }
           

                if (this.branchObj.branchColourCode != "" && this.branchObj.branchColourCode != null) {
                  this.branchColor = this.branchObj.branchColourCode;
                  var split = this.branchObj.branchColourCode.split(",");
                  var split1 = split[0];
                  var split2 = split1.split("(")
                  var split3 = split2[1]
                  document.documentElement.style.setProperty('--hue-color', split3);
                  var buttonValue = Number(split3);
                  if ((buttonValue >= 0 && buttonValue <= 30) || (buttonValue >= 60 && buttonValue <= 90)
                    || (buttonValue >= 120 && buttonValue <= 150) || (buttonValue >= 190 && buttonValue <= 360))
                    document.documentElement.style.setProperty('--button_color', 'white')
                  else {
                    document.documentElement.style.setProperty('--button_color', 'black')
                  }
                }


              }
              localStorage.removeItem("BranchListId");
            });
          }
        });
      }
    } catch (e) {
      console.log(e);
    }
  }
  CheckSettlementValiations(): boolean {
    try {
      if (this.settelementCash == false && this.settelementCredit == false) {
        $("#lblerrormsg").show();
        document.getElementById("lblerrormsg").innerHTML = "Please Enter Required Fields."
        $("#lblerrormsg").delay(5000).hide(10);
        return false;
      }
      if (this.settelementCredit && (this.branchObj.creditLimit == 0 || this.branchObj.creditLimit == null)) {
        $("#lblerrormsg").show();
        document.getElementById("lblerrormsg").innerHTML = "Please Enter Required Fields."
        $("#lblerrormsg").delay(5000).hide(10);
        return false;
      }

      else
        return true;
    }

    catch (e) {
      console.log(e);
    }
  }

  CheckAdminValidations(): boolean {
    try {
      let isNewAdminUser = this.branchObj.userObj.userId == 0 || this.branchObj.userObj.userId == null || this.branchObj.userObj.userId == undefined;
      if (this.branchObj.userObj.backSystemCompanyId == 0 || this.branchObj.userObj.backSystemCompanyId == null || this.branchObj.userObj.backSystemCompanyId == undefined) {
        /*      box input id here*/
        document.getElementById("backSystemCompanyId").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelofCompanyinfo").style.color = "red";
        /*   message id here*/
        document.getElementById("requireduserbackSystemCompanyId").innerHTML = "Required Company";
        setTimeout(function () {

          document.getElementById("backSystemCompanyId").classList.remove("newRequired-BoxColor");
          document.getElementById("labelofCompanyinfo").style.color = "";
          document.getElementById("requireduserbackSystemCompanyId").innerHTML = "";
        }
          , 8000);
      }
      if (this.branchObj.userObj.backSystemCompanyCustomer == "" || this.branchObj.userObj.backSystemCompanyCustomer == null || this.branchObj.userObj.backSystemCompanyCustomer == undefined) {
        /*      box input id here*/
        document.getElementById("backSystemCompanyCustomer").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelcustomercode").style.color = "red";
        /*   message id here*/
        document.getElementById("requireduserbackSystemCompanyCustomer").innerHTML = "Required Customer";
        setTimeout(function () {

          document.getElementById("backSystemCompanyCustomer").classList.remove("newRequired-BoxColor");
          document.getElementById("labelcustomercode").style.color = "";
          document.getElementById("requireduserbackSystemCompanyCustomer").innerHTML = "";
        }
          , 8000);
      }

      if (this.branchObj.userObj.title == "" || this.branchObj.userObj.title == null || this.branchObj.userObj.title == undefined) {
        /*      box input id here*/
        document.getElementById("tbtitle").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labeltitleuser").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredusertitle").innerHTML = "Required Title";
        setTimeout(function () {

          document.getElementById("tbtitle").classList.remove("newRequired-BoxColor");
          document.getElementById("labeltitleuser").style.color = "";
          document.getElementById("requiredusertitle").innerHTML = "";
        }
          , 8000);
      }
      if (this.branchObj.userObj.loginName == "" || this.branchObj.userObj.loginName == null || this.branchObj.userObj.loginName == undefined) {
        /*      box input id here*/
        document.getElementById("tbloginName").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelloginuser").style.color = "red";
        /*   message id here*/
        document.getElementById("loginnamemessage").innerHTML = "Required Login Name";
        setTimeout(function () {

          document.getElementById("tbloginName").classList.remove("newRequired-BoxColor");
          document.getElementById("labelloginuser").style.color = "";
          document.getElementById("loginnamemessage").innerHTML = "";
        }
          , 8000);
      }
      if (this.branchObj.userObj.firstName == "" || this.branchObj.userObj.firstName == null || this.branchObj.userObj.firstName == undefined) {
        /*      box input id here*/
        document.getElementById("tbfirstName").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelnamefuser").style.color = "red";
        /*   message id here*/
        document.getElementById("requireduserfirst").innerHTML = "Required First Name";
        setTimeout(function () {

          document.getElementById("tbfirstName").classList.remove("newRequired-BoxColor");
          document.getElementById("labelnamefuser").style.color = "";
          document.getElementById("requireduserfirst").innerHTML = "";
        }
          , 8000);
      }
      if (this.branchObj.userObj.lastName == "" || this.branchObj.userObj.lastName == null || this.branchObj.userObj.lastName == undefined) {
        /*      box input id here*/
        document.getElementById("tblastName").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelnameluser").style.color = "red";
        /*   message id here*/
        document.getElementById("requireduserlast").innerHTML = "Required Last Name";
        setTimeout(function () {

          document.getElementById("tblastName").classList.remove("newRequired-BoxColor");
          document.getElementById("labelnameluser").style.color = "";
          document.getElementById("requireduserlast").innerHTML = "";
        }
          , 8000);
      }
      if (isNewAdminUser && (this.branchObj.userObj.password == "" || this.branchObj.userObj.password == null || this.branchObj.userObj.password == undefined)) {
        /*      box input id here*/
        document.getElementById("tbpassword").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelpswduser").style.color = "red";
        /*   message id here*/
        document.getElementById("requireduserpswd").innerHTML = "Required Password";
        setTimeout(function () {

          document.getElementById("tbpassword").classList.remove("newRequired-BoxColor");
          document.getElementById("labelpswduser").style.color = "";
          document.getElementById("requireduserpswd").innerHTML = "";
        }
          , 8000);
      }
      if (this.branchObj.userObj.email == "" || this.branchObj.userObj.email == null || this.branchObj.userObj.email == undefined) {
        /*      box input id here*/
        document.getElementById("tbAdminemail").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelemailadres").style.color = "red";
        /*   message id here*/
        document.getElementById("requireduseremail").innerHTML = "Required Email";
        setTimeout(function () {

          document.getElementById("tbAdminemail").classList.remove("newRequired-BoxColor");
          document.getElementById("labelemailadres").style.color = "";
          document.getElementById("requireduseremail").innerHTML = "";
        }
          , 8000);
      }
      if (this.branchObj.userObj.mobile == "" || this.branchObj.userObj.mobile == null || this.branchObj.userObj.mobile == undefined) {
        /*      box input id here*/
        document.getElementById("tbAdminmobile").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelmobileuser").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredusermobile").innerHTML = "Required Mobile";
        setTimeout(function () {

          document.getElementById("tbAdminmobile").classList.remove("newRequired-BoxColor");
          document.getElementById("labelmobileuser").style.color = "";
          document.getElementById("requiredusermobile").innerHTML = "";
        }
          , 8000);
      }
      if (this.branchObj.userObj.telephone == "" || this.branchObj.userObj.telephone == null || this.branchObj.userObj.telephone == undefined) {
        /*      box input id here*/
        document.getElementById("tbAdmintelephone").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelteleuser").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredusertelephone").innerHTML = "Required Telephone";
        setTimeout(function () {

          document.getElementById("tbAdmintelephone").classList.remove("newRequired-BoxColor");
          document.getElementById("labelteleuser").style.color = "";
          document.getElementById("requiredusertelephone").innerHTML = "";
        }
          , 8000);
      }
      if (this.branchObj.userObj.designation == "" || this.branchObj.userObj.designation == null || this.branchObj.userObj.designation == undefined) {
        /*      box input id here*/
        document.getElementById("tbdesignation").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labeldesignuser").style.color = "red";
        /*   message id here*/
        document.getElementById("requireduserdesignation").innerHTML = "Required Designation";
        setTimeout(function () {

          document.getElementById("tbdesignation").classList.remove("newRequired-BoxColor");
          document.getElementById("labeldesignuser").style.color = "";
          document.getElementById("requireduserdesignation").innerHTML = "";
        }
          , 8000);
      }

      if (this.branchObj.userObj.isBranchAdmin == false) {

        document.getElementById("requireduseradministrator").innerHTML = "Required";
        setTimeout(function () {


          document.getElementById("requireduseradministrator").innerHTML = "";
        }
          , 8000);
      }

      if (this.branchObj.userObj.title == "" || this.branchObj.userObj.title == undefined || this.branchObj.userObj.title == null ||
        this.branchObj.userObj.firstName == "" || this.branchObj.userObj.firstName == null || this.branchObj.userObj.firstName == undefined
        || this.branchObj.userObj.lastName == "" || this.branchObj.userObj.lastName == null || this.branchObj.userObj.lastName == undefined
        || this.branchObj.userObj.loginName == "" || this.branchObj.userObj.loginName == null || this.branchObj.userObj.loginName == undefined
        || (isNewAdminUser && (this.branchObj.userObj.password == "" || this.branchObj.userObj.password == null || this.branchObj.userObj.password == undefined))
        || this.branchObj.userObj.email == "" || this.branchObj.userObj.email == null || this.branchObj.userObj.email == undefined
        || this.branchObj.userObj.mobile == "" || this.branchObj.userObj.mobile == null || this.branchObj.userObj.mobile == undefined
        || this.branchObj.userObj.telephone == "" || this.branchObj.userObj.telephone == null || this.branchObj.userObj.telephone == undefined
        || this.branchObj.userObj.designation == "" || this.branchObj.userObj.designation == null || this.branchObj.userObj.designation == undefined
        || this.branchObj.userObj.isBranchAdmin == false
        || this.branchObj.userObj.backSystemCompanyId == 0 || this.branchObj.userObj.backSystemCompanyId == null || this.branchObj.userObj.backSystemCompanyId == undefined
        || this.branchObj.userObj.backSystemCompanyCustomer == "" || this.branchObj.userObj.backSystemCompanyCustomer == null || this.branchObj.userObj.backSystemCompanyCustomer == undefined) {
        return false;
      }
      if (!this.validateEmail(this.branchObj.userObj.email)) {
        /*      box input id here*/
        document.getElementById("tbAdminemail").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelemailadres").style.color = "red";
        /*   message id here*/
        document.getElementById("requireduseremail").innerHTML = "Email Pattern Must be Followed";
        setTimeout(function () {

          document.getElementById("tbAdminemail").classList.remove("newRequired-BoxColor");
          document.getElementById("labelemailadres").style.color = "";
          document.getElementById("requireduseremail").innerHTML = "";
        }
          , 8000);
        return false;
      }
      if (!this.validateMobileNumber(this.branchObj.userObj.mobile)) {
        /*      box input id here*/
        document.getElementById("tbAdminmobile").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelmobileuser").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredusermobile").innerHTML = "Mobile Start with + Sign";
        setTimeout(function () {

          document.getElementById("tbAdminmobile").classList.remove("newRequired-BoxColor");
          document.getElementById("labelmobileuser").style.color = "";
          document.getElementById("requiredusermobile").innerHTML = "";
        }
          , 8000);
        return false;
      }
      if (!this.validateNumber(this.branchObj.userObj.telephone)) {
        /*      box input id here*/
        document.getElementById("tbAdmintelephone").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelteleuser").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredusertelephone").innerHTML = "Telephone Start with + Sign";
        setTimeout(function () {

          document.getElementById("tbAdmintelephone").classList.remove("newRequired-BoxColor");
          document.getElementById("labelteleuser").style.color = "";
          document.getElementById("requiredusertelephone").innerHTML = "";
        }
          , 8000);
        return false;
      }
      else {
        // this.stepFour = true;
        return true;
      }
    }

    catch (e) {
      console.log(e);
    }
  }

  validateEmail(email) {
    const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regularExpression.test(String(email).toLowerCase());
  }
  validateMobileNumber(number) {
    // const regularExp = /^\+?([0-9]{2})\)?[-. ]?([0-9]{4})[-. ]?([0-9]{4})$/;
    const regularExp = /\+[0-9]+/;

    return regularExp.test(String(number));
  }

  validateNumber(number) {
    const regularExp = /[0-9]+/;
    return regularExp.test(String(number));
  }

  CheckChildBranchesLimit(): Observable<boolean> {
    try {
      let flag = false;
      var subject = new Subject<boolean>();
      let param = "";
      let isAgency;
      if (this.branchObj.immediateParent == "" || this.branchObj.immediateParent == null
        || this.branchObj.immediateParent == this.branchObj.agencyId) {
        isAgency = true;
      }
      else
        isAgency = false;
      if (isAgency == true)
        param = this.branchObj.agencyId;
      else
        param = this.branchObj.immediateParent;
      this.branchService.CheckChildBranchesLimit(param, isAgency).subscribe((data) => {
        if (data != null && data != undefined) {
          if (data == -1) {
            flag = false;
            subject.next(flag);
            $("#lblerrormsg").show();
            document.getElementById("lblerrormsg").innerHTML = "Maximum Branch Limit Reached."
            $("#lblerrormsg").delay(5000).hide(10);
          }
          else {
            flag = true;
            subject.next(flag);
          }
        }
        else {
          flag = false;
          subject.next(flag);
          $("#lblerrormsg").show();
          document.getElementById("lblerrormsg").innerHTML = "Something went wrong."
          $("#lblerrormsg").delay(5000).hide(10);
        }
      });
      return subject.asObservable();

    }
    catch (e) {
      console.log(e);
    }
  }





  CloseInformation() {
    this.router.navigateByUrl('/agencyList');
  }

  ManagerUserChange(value, index) {
    //console.log(index)
    try {
      if (value != null) {
        for (let i = 0; i < this.parentUsertList.length; i++) {
          if (this.parentUsertList[i].userId == value) {
            this.managerList[index].managerName = this.parentUsertList[i].fullname;
            break;
          }
        }
        for (let j = 0; j < this.managerList.length - 1; j++) {
          if (this.managerList[j].userId == this.managerList[index].userId) {
            document.getElementById("requiredManagerName" + index).innerHTML = "Already Selected! Please Select Other One";
            document.getElementById("managerNameInput" + index).classList.add("newRequired-BoxColor");
            document.getElementById("labelManagerName" + index).style.color = "red";
            document.getElementById("ManagerDetailsBtn").setAttribute('disabled', 'disabled');
            document.getElementById("ManagerDetailsBtn").style.background = "silver";
            document.getElementById("ManagerDetailsBackBtn").style.display = "none";


          }
          else {
            document.getElementById("managerNameInput" + index).classList.remove("newRequired-BoxColor");
            document.getElementById("labelManagerName" + index).style.color = "";
            document.getElementById("requiredManagerName" + index).innerHTML = "";
            document.getElementById("ManagerDetailsBtn").removeAttribute('disabled');
            document.getElementById("ManagerDetailsBtn").style.background = "";
            document.getElementById("ManagerDetailsBackBtn").style.display = "block";
          }
        }
      }
      else {
        document.getElementById("managerNameInput" + index).classList.remove("newRequired-BoxColor");
        document.getElementById("labelManagerName" + index).style.color = "";
        document.getElementById("requiredManagerName" + index).innerHTML = "";
        document.getElementById("ManagerDetailsBtn").removeAttribute('disabled');
        document.getElementById("ManagerDetailsBtn").style.background = "";
        document.getElementById("ManagerDetailsBackBtn").style.display = "block";

      }

    }
    catch (e) {

    }
  }

  BackOfficeInfobackClick() {
    this.BackOfficeInfoComplete = false;
    this.branchInfoComplete = true;
    this.stepTwo = false;
    this.backsystemOfficeProperties = []
  }
  managerInfoBackClick() {
    this.managerInfoComplete = false;
    this.stepFive = false;
    this.adminInfoComplete = true;
  }
  settleModeBackClick() {
    this.settleModeComplete = false;
    this.managerInfoComplete = true;
    this.stepFour = false;
  }

  AgencyRightsBackClick = (): void => {
    this.backsystemOfficeProperties = [];
    this.backsystemgetinfo(this.branchObj.branchId);
    if (this.agencyAG01 == "AG01") {
      this.agencyRightsComplete = false;
      this.BackOfficeInfoComplete = true;
      this.stepThree = false;
    }
    else {
      this.branchInfoComplete = true;
      this.stepOne = true;
      this.BackOfficeInfoComplete = false;
      this.stepTwo = false;
      this.agencyRightsComplete = false;
      this.stepThree = false;
    }

  }

  adminInfoBackClick() {
    this.adminInfoComplete = false;
    this.agencyRightsComplete = true;
    this.stepFour = false;

  }
  SupplierRightsBackClick() {
    this.supplierRightsComplete = false;
    this.managerInfoComplete = true;
    this.stepSix = false;
  }
  GetUsers() {
    try {
      let param = "";
      let isAgency;
      if (this.branchObj.immediateParent == "" || this.branchObj.immediateParent == null
        || this.branchObj.immediateParent == this.branchObj.agencyId) {
        isAgency = true;
      }
      else
        isAgency = false;
      if (isAgency == true)
        param = this.branchObj.agencyId;
      else
        param = this.branchObj.immediateParent;
      this.branchService.GetUsersByParent(param, isAgency, this.branchObj.branchId).subscribe((data) => {
        this.managerUserList$ = of(data);
        this.parentUsertList = data;
      })
    }
    catch (e) { }
  }
  UserRoleAdministrator(event) {
    if (event.target.checked) {
      this.branchObj.userObj.userRoleId = 1;
    }
    else {
      this.branchObj.userObj.userRoleId = 0;
    }
  }

  UserRoleChange(event) {
    if (this.branchObj.userObj.isBranchAdmin == true)
      this.branchObj.userObj.userRoleId = 1;
    else if (this.branchObj.userObj.isAgent == true)
      this.branchObj.userObj.userRoleId = 2;
    if (this.branchObj.userObj.isBranchAdmin == true && this.branchObj.userObj.isAgent == true)
      this.branchObj.userObj.userRoleId = 1;
    else if (this.branchObj.userObj.isBranchAdmin == false && this.branchObj.userObj.isAgent == false)
      this.branchObj.userObj.userRoleId = 0;
  }


  AdminCheckboxChange(ev) {

    try {
      if (ev.target.checked) {
        this.branchObj.agencyRightObj.profileUpdate = true;
        this.branchObj.agencyRightObj.beneficiaryAccount = true;
        this.branchObj.agencyRightObj.paymentProcess = true;
        this.branchObj.agencyRightObj.creditLimit = true;
        this.branchObj.agencyRightObj.notifications = true;
        this.branchObj.agencyRightObj.revenueManagement = true;
        this.branchObj.agencyRightObj.offlineRequest = true;
        this.branchObj.agencyRightObj.offlineSettings = true;
        this.branchObj.agencyRightObj.supplierManagement = true;
        this.branchObj.agencyRightObj.accountManagement = true;
        this.branchObj.agencyRightObj.bookings = true;
        this.branchObj.agencyRightObj.cms = true;
        this.branchObj.agencyRightObj.reports = true;
        this.branchObj.agencyRightObj.dashboard = true;
        this.branchObj.agencyRightObj.reportsManagement = true;
      }
      else {
        this.branchObj.agencyRightObj.profileUpdate = false;
        this.branchObj.agencyRightObj.beneficiaryAccount = false;
        this.branchObj.agencyRightObj.paymentProcess = false;
        this.branchObj.agencyRightObj.creditLimit = false;
        this.branchObj.agencyRightObj.notifications = false;
        this.branchObj.agencyRightObj.revenueManagement = false;
        this.branchObj.agencyRightObj.offlineRequest = false;
        this.branchObj.agencyRightObj.offlineSettings = false;
        this.branchObj.agencyRightObj.supplierManagement = false;
        this.branchObj.agencyRightObj.accountManagement = false;
        this.branchObj.agencyRightObj.bookings = false;
        this.branchObj.agencyRightObj.cms = false;
        this.branchObj.agencyRightObj.reports = false;
        this.branchObj.agencyRightObj.dashboard = false;
        this.branchObj.agencyRightObj.reportsManagement = false;
      }

    }
    catch (e) {
    }

  }






  AdministratorCheckboxChange(event) {
    try {
      if (event.target.checked) {
        this.branchObj.userObj.adminUser.profileUpdate = true;
        this.branchObj.userObj.adminUser.beneficiaryAccount = true;
        this.branchObj.userObj.adminUser.paymentProcess = true;
        this.branchObj.userObj.adminUser.creditLimit = true;
        this.branchObj.userObj.adminUser.notifications = true;
        this.branchObj.userObj.adminUser.revenueManagement = true;
        this.branchObj.userObj.adminUser.offlineRequest = true;
        this.branchObj.userObj.adminUser.offlineSettings = true;
        this.branchObj.userObj.adminUser.supplierManagement = true;
        this.branchObj.userObj.adminUser.accountManagement = true;
        this.branchObj.userObj.adminUser.bookings = true;
        this.branchObj.userObj.adminUser.cms = true;
        this.branchObj.userObj.adminUser.reports = true;
        this.branchObj.userObj.adminUser.dashboard = true;
        this.branchObj.userObj.adminUser.reportsManage = true;
      }
      else {
        this.branchObj.userObj.adminUser.profileUpdate = false;
        this.branchObj.userObj.adminUser.beneficiaryAccount = false;
        this.branchObj.userObj.adminUser.paymentProcess = false;
        this.branchObj.userObj.adminUser.creditLimit = false;
        this.branchObj.userObj.adminUser.notifications = false;
        this.branchObj.userObj.adminUser.revenueManagement = false;
        this.branchObj.userObj.adminUser.offlineRequest = false;
        this.branchObj.userObj.adminUser.offlineSettings = false;
        this.branchObj.userObj.adminUser.supplierManagement = false;
        this.branchObj.userObj.adminUser.accountManagement = false;
        this.branchObj.userObj.adminUser.bookings = false;
        this.branchObj.userObj.adminUser.cms = false;
        this.branchObj.userObj.adminUser.reports = false;
        this.branchObj.userObj.adminUser.dashboard = false;
        this.branchObj.userObj.adminUser.reportsManage = false;
      }

    }
    catch (e) {
    }
  }

  PaymentCheckboxChange(event) {
    try {
      if (event.target.checked) {
        this.branchObj.agencyRightObj.addPayment = true;
        this.branchObj.agencyRightObj.approvePayment = true;
        this.branchObj.agencyRightObj.deletePayment = true;
        // this.branchObj.userObj.adminUser.addPayment = true;
        //this.branchObj.userObj.adminUser.approvePayment = true;
        //this.branchObj.userObj.adminUser.deletePayment = true;
      }
      else {
        this.branchObj.agencyRightObj.addPayment = false;
        this.branchObj.agencyRightObj.approvePayment = false;
        this.branchObj.agencyRightObj.deletePayment = false;

        // this.branchObj.userObj.adminUser.addPayment = false;
        //this.branchObj.userObj.adminUser.approvePayment = false;
        //this.branchObj.userObj.adminUser.deletePayment = false;
      }
    }
    catch (e) {

    }
  }

  PaymentUserCheckboxChange(event) {
    try {
      if (event.target.checked) {

        this.branchObj.userObj.adminUser.addPayment = true;
        this.branchObj.userObj.adminUser.approvePayment = true;
        this.branchObj.userObj.adminUser.deletePayment = true;
      }
      else {

        this.branchObj.userObj.adminUser.addPayment = false;
        this.branchObj.userObj.adminUser.approvePayment = false;
        this.branchObj.userObj.adminUser.deletePayment = false;
      }
    }
    catch (e) {

    }
  }

  OfflineUserCheckboxChange(ev) {
    try {

      if (ev.target.checked) {
        this.branchObj.userObj.adminUser.offlineBooking = true;
        this.branchObj.userObj.adminUser.offlineTicket = true;
        this.branchObj.userObj.adminUser.offlineRefund = true;
        this.branchObj.userObj.adminUser.offlineVoid = true;
        this.branchObj.userObj.adminUser.offlineDealsByCMS = true;

      } else {
        this.branchObj.userObj.adminUser.offlineBooking = false;
        this.branchObj.userObj.adminUser.offlineTicket = false;
        this.branchObj.userObj.adminUser.offlineRefund = false;
        this.branchObj.userObj.adminUser.offlineVoid = false;
        this.branchObj.userObj.adminUser.offlineDealsByCMS = false;

      }

    } catch (e) { }
  }

  AccountUserCheckboxChange(event) {
    try {
      if (event.target.checked) {
        this.branchObj.userObj.adminUser.account = true;
        this.branchObj.userObj.adminUser.users = true;
        this.branchObj.userObj.adminUser.agencyManagement = true;
        this.branchObj.userObj.adminUser.branchManagement = true;
        // this.branchObj.userObj.adminUser.logs = true;
        //this.branchObj.userObj.adminUser.currency = true;
      }
      else {
        this.branchObj.userObj.adminUser.account = false;
        this.branchObj.userObj.adminUser.users = false;
        this.branchObj.userObj.adminUser.agencyManagement = true;
        this.branchObj.userObj.adminUser.branchManagement = true;
        // this.branchObj.userObj.adminUser.logs = false;
        //this.branchObj.userObj.adminUser.currency = false;
      }
    }
    catch (e) {

    }
  }

  BookingUserCheckboxChange(event) {
    try {
      if (event.target.checked) {
        this.branchObj.userObj.adminUser.searchBookings = true;
        this.branchObj.userObj.adminUser.viewBookings = true;
        this.branchObj.userObj.adminUser.updateBookings = true;
        this.branchObj.userObj.adminUser.viewSubAgentBookings = true;
        this.branchObj.userObj.adminUser.issueTicket = true;
        this.branchObj.userObj.adminUser.cancelPNR = true;
        this.branchObj.userObj.adminUser.refund = true;
        this.branchObj.userObj.adminUser.importPNR = true;
        this.branchObj.userObj.adminUser.exchangeTicket = true;
        this.branchObj.userObj.adminUser.quotations = true;
        this.branchObj.userObj.adminUser.fareRules = true;
        this.branchObj.userObj.adminUser.voidTicket = true;
      }
      else {
        this.branchObj.userObj.adminUser.searchBookings = false;
        this.branchObj.userObj.adminUser.viewBookings = false;
        this.branchObj.userObj.adminUser.updateBookings = false;
        this.branchObj.userObj.adminUser.viewSubAgentBookings = false;
        this.branchObj.userObj.adminUser.issueTicket = false;
        this.branchObj.userObj.adminUser.cancelPNR = false;
        this.branchObj.userObj.adminUser.refund = false;
        this.branchObj.userObj.adminUser.importPNR = false;
        this.branchObj.userObj.adminUser.exchangeTicket = false;
        this.branchObj.userObj.adminUser.quotations = false;
        this.branchObj.userObj.adminUser.fareRules = false;
        this.branchObj.userObj.adminUser.voidTicket = false;
      }
    }
    catch (e) {
    }
  }

  OfflineCheckboxChange(ev) {
    try {

      if (ev.target.checked) {
        this.branchObj.agencyRightObj.offlineBooking = true;
        this.branchObj.agencyRightObj.offlineTicket = true;
        this.branchObj.agencyRightObj.offlineRefund = true;
        this.branchObj.agencyRightObj.offlineVoid = true;
        this.branchObj.agencyRightObj.offlineDealsByCMS = true;

      } else {
        this.branchObj.agencyRightObj.offlineBooking = false;
        this.branchObj.agencyRightObj.offlineTicket = false;
        this.branchObj.agencyRightObj.offlineRefund = false;
        this.branchObj.agencyRightObj.offlineVoid = false;
        this.branchObj.agencyRightObj.offlineDealsByCMS = false;

      }

    } catch (e) { }
  }


  AccountCheckboxChange(event) {
    try {
      if (event.target.checked) {
        this.branchObj.agencyRightObj.account = true;
        this.branchObj.agencyRightObj.users = true;
        this.branchObj.agencyRightObj.agencyManagement = true;
        this.branchObj.agencyRightObj.branchManagement = true;
        // this.branchObj.userObj.adminUser.logs = true;
        //this.branchObj.userObj.adminUser.currency = true;
      }
      else {
        this.branchObj.agencyRightObj.account = false;
        this.branchObj.agencyRightObj.users = false;
        this.branchObj.agencyRightObj.agencyManagement = false;
        this.branchObj.agencyRightObj.branchManagement = false;
        // this.branchObj.userObj.adminUser.logs = false;
        //this.branchObj.userObj.adminUser.currency = false;
      }
    }
    catch (e) {

    }
  }


  BookingCheckboxChange(event) {
    try {
      if (event.target.checked) {
        this.branchObj.agencyRightObj.searchBookings = true;
        this.branchObj.agencyRightObj.viewBookings = true;
        this.branchObj.agencyRightObj.updateBookings = true;
        this.branchObj.agencyRightObj.viewSubAgentBookings = true;
        this.branchObj.agencyRightObj.issueTicket = true;
        this.branchObj.agencyRightObj.cancelPNR = true;
        this.branchObj.agencyRightObj.refund = true;
        this.branchObj.agencyRightObj.importPNR = true;
        this.branchObj.agencyRightObj.exchange = true;
        this.branchObj.agencyRightObj.quotations = true;
        this.branchObj.agencyRightObj.fareRulesResult = true;
        this.branchObj.agencyRightObj.voidTicket = true;
      }
      else {
        this.branchObj.agencyRightObj.searchBookings = false;
        this.branchObj.agencyRightObj.viewBookings = false;
        this.branchObj.agencyRightObj.updateBookings = false;
        this.branchObj.agencyRightObj.viewSubAgentBookings = false;
        this.branchObj.agencyRightObj.issueTicket = false;
        this.branchObj.agencyRightObj.cancelPNR = false;
        this.branchObj.agencyRightObj.refund = false;
        this.branchObj.agencyRightObj.importPNR = false;
        this.branchObj.agencyRightObj.exchange = false;
        this.branchObj.agencyRightObj.quotations = false;
        this.branchObj.agencyRightObj.fareRulesResult = false;
        this.branchObj.agencyRightObj.voidTicket = false;
      }
    }
    catch (e) {
    }
  }
  AgentCheckboxChange(event) {
    try {
      if (event.target.checked) {
        this.branchObj.userObj.agentUser.book = true;
        this.branchObj.userObj.agentUser.issueTicket = true;
        this.branchObj.userObj.agentUser.issuePNR = true;
        this.branchObj.userObj.agentUser.cancelTicket = true;
        this.branchObj.userObj.agentUser.cancelPNR = true;
        this.branchObj.userObj.agentUser.quotations = true;
        this.branchObj.userObj.agentUser.voidTicket = true;
        this.branchObj.userObj.agentUser.fareRules_Result = true;
        this.branchObj.userObj.agentUser.offlineRequest = true;
        this.branchObj.userObj.agentUser.offlineBooking = true;
        this.branchObj.userObj.agentUser.reprice = true;
        this.branchObj.userObj.agentUser.markup = true;
        this.branchObj.userObj.agentUser.refund = true;
        this.branchObj.userObj.agentUser.offlineRefund = true;
        this.branchObj.userObj.agentUser.exchange = true;
        this.branchObj.userObj.agentUser.calenderSearch = true;
        this.branchObj.userObj.agentUser.recentSearch = true;
        this.branchObj.userObj.agentUser.adminPanelLogin = true;
      }
      else {
        this.branchObj.userObj.agentUser.book = false;
        this.branchObj.userObj.agentUser.issueTicket = false;
        this.branchObj.userObj.agentUser.issuePNR = false;
        this.branchObj.userObj.agentUser.cancelTicket = false;
        this.branchObj.userObj.agentUser.cancelPNR = false;
        this.branchObj.userObj.agentUser.quotations = false;
        this.branchObj.userObj.agentUser.voidTicket = false;
        this.branchObj.userObj.agentUser.fareRules_Result = false;
        this.branchObj.userObj.agentUser.offlineRequest = false;
        this.branchObj.userObj.agentUser.offlineBooking = false;
        this.branchObj.userObj.agentUser.reprice = false;
        this.branchObj.userObj.agentUser.markup = false;
        this.branchObj.userObj.agentUser.refund = false;
        this.branchObj.userObj.agentUser.offlineRefund = false;
        this.branchObj.userObj.agentUser.exchange = false;
        this.branchObj.userObj.agentUser.calenderSearch = false;
        this.branchObj.userObj.agentUser.recentSearch = false;
        this.branchObj.userObj.agentUser.adminPanelLogin = false;
      }
    }
    catch (e) {

    }
  }
  AgentBookingCheckboxChange(event) {
    try {
      if (event.target.checked) {
        this.branchObj.userObj.agentUser.newBookings = true;
        this.branchObj.userObj.agentUser.myBookings = true;
        this.branchObj.userObj.agentUser.searchBookings = true;
      }
      else {
        this.branchObj.userObj.agentUser.newBookings = false;
        this.branchObj.userObj.agentUser.myBookings = false;
        this.branchObj.userObj.agentUser.searchBookings = false;
      }
    }
    catch (e) {

    }
  }
  GetSuppliersByParent() {
    try {

      if (this.branchObj.immediateParent != "") {
        this.branchService.GetSuppliersByParent(this.branchObj.immediateParent).subscribe((data) => {
          this.supplierRightsData = data;
          if (this.supplierRightsData.dataList.length > 0) {
            if (this.branchObj.agencySupplierList.length > 0) {
              for (let i = 0; i < this.supplierRightsData.dataList.length; i++) {
                let suppliers = new SupplierRightsForAgencyAndBranchProperties();
                suppliers.supplierName = this.supplierRightsData.dataList[i].name;
                suppliers.supplierTypeId = this.supplierRightsData.dataList[i].supplierTypeId;
                suppliers.supplierId = this.supplierRightsData.dataList[i].supplierId;

                for (let j = 0; j < this.branchObj.agencySupplierList.length; j++) {
                  let agencySuppliersBool = new SupplierRightsForAgencyAndBranchBooleanProperties();
                  if (this.branchObj.agencySupplierList[j].supplierId == this.supplierRightsData.dataList[i].supplierId) {
                    suppliers.supplierStatus = this.branchObj.agencySupplierList[j].status;
                    agencySuppliersBool.canBook = this.branchObj.agencySupplierList[j].canBook;
                    agencySuppliersBool.canIssue = this.branchObj.agencySupplierList[j].canIssue;
                    agencySuppliersBool.canRefund = this.branchObj.agencySupplierList[j].canRefund;
                    agencySuppliersBool.canSearch = this.branchObj.agencySupplierList[j].canSearch;
                    agencySuppliersBool.canVoid = this.branchObj.agencySupplierList[j].canVoid;
                    agencySuppliersBool.supplierOficeId = this.branchObj.agencySupplierList[j].supplierOficeId.toString();
                    suppliers.supplierBoolean.push(agencySuppliersBool);

                  }
                }
                for (let k = 0; k < this.supplierRightsData.dataList[i].supplierOficeIdlist.length; k++) {
                  let id = new SuppliersOfficeIds();
                  id.officeIds = this.supplierRightsData.dataList[i].supplierOficeIdlist[k].officeId;
                  suppliers.supplierOfficeIdsCounter += 1;
                  suppliers.suppliersOfficeIds.push(id);
                }

                if (suppliers.supplierTypeId == 1) {
                  this.agencySuppliers.push(suppliers);
                }
                else if (suppliers.supplierTypeId == 3) {
                  this.insuranceSuppliers.push(suppliers);
                }


              }

            }
            else {
              for (let i = 0; i < this.supplierRightsData.dataList.length; i++) {
                let suppliers = new SupplierRightsForAgencyAndBranchProperties();
                suppliers.supplierName = this.supplierRightsData.dataList[i].name;
                suppliers.supplierId = this.supplierRightsData.dataList[i].supplierId;
                suppliers.supplierTypeId = this.supplierRightsData.dataList[i].supplierTypeId;
                for (let k = 0; k < this.supplierRightsData.dataList[i].supplierOficeIdlist.length; k++) {
                  let id = new SuppliersOfficeIds();
                  id.officeIds = this.supplierRightsData.dataList[i].supplierOficeIdlist[k].officeId;
                  suppliers.supplierOfficeIdsCounter += 1;
                  suppliers.suppliersOfficeIds.push(id);
                }

                if (suppliers.supplierTypeId == 1) {
                  this.agencySuppliers.push(suppliers);
                }
                else if (suppliers.supplierTypeId == 3) {
                  this.insuranceSuppliers.push(suppliers);
                }


              }

            }
          }
        })
      }
    }
    catch (e) { }
  }
  CheckParentCredit(value) {
    try {

      let param = "";
      let agencyID = "";
      if (this.branchObj.immediateParent == "" || this.branchObj.immediateParent == null
        || this.branchObj.immediateParent == this.branchObj.agencyId) {
        this.isAgency = true;
      }
      else
        this.isAgency = false;
      if (this.isAgency == true)
        param = this.branchObj.agencyId;
      else
        param = this.branchObj.immediateParent;
      if (this.branchObj.branchId == "") {
        agencyID = "AG"

      }
      else {
        agencyID = this.branchObj.branchId
      }

      this.branchService.CheckParentCreditLimit(param, this.isAgency, agencyID).subscribe((data) => {
        this.creditLimitChecking = data;

        if (this.creditLimitChecking.returnCredit != 0 && value > this.creditLimitChecking.returnCredit) {
          this.creditCheck = true;
          document.getElementById("tbCredit").classList.add("newRequired-BoxColor");
          /*   label id here*/
          document.getElementById("labelcredit").style.color = "red";
          /*   message id here*/
          document.getElementById("requiredcreditlimit").innerHTML = "Credit Should less from Parent";
          setTimeout(function () {

            document.getElementById("tbCredit").classList.remove("newRequired-BoxColor");
            document.getElementById("labelcredit").style.color = "";
            document.getElementById("requiredcreditlimit").innerHTML = "";
          }
            , 8000);

          return false;
        }
        else {
          this.creditCheck = false;
        }

        if (value < this.pendingCreditChange) {
          let newValue: number = 0;
          newValue = this.pendingCreditChange - value;
          if (this.creditLimitChecking.returnPendingCredit - newValue < 0) {
            this.pendingCreditDecreased = true;
            document.getElementById("tbCredit").classList.add("newRequired-BoxColor");
            /*   label id here*/
            document.getElementById("labelcredit").style.color = "red";
            /*   message id here*/
            document.getElementById("requiredcreditlimit").innerHTML = "You cannot decrease Credit Limit";
            setTimeout(function () {

              document.getElementById("tbCredit").classList.remove("newRequired-BoxColor");
              document.getElementById("labelcredit").style.color = "";
              document.getElementById("requiredcreditlimit").innerHTML = "";
            }
              , 8000);

            return false;
          }
          else {
            this.pendingCreditDecreased = false;
          }
        }
        else {
          this.pendingCreditDecreased = false;
        }
      })
    }
    catch (e) { }
  }
  SaveSupplierRights() {
    try {
      if (Number(localStorage.getItem("UserId")) != 0 && Number(localStorage.getItem("UserId")) != undefined && Number(localStorage.getItem("UserId")) != null) {

        for (let i = 0; i < this.agencySuppliers.length; i++) {
          for (let j = 0; j < this.agencySuppliers[i].supplierBoolean.length; j++) {
            if (this.agencySuppliers[i].supplierBoolean[j].supplierOficeId == null
              || this.agencySuppliers[i].supplierBoolean[j].supplierOficeId == undefined
              || this.agencySuppliers[i].supplierBoolean[j].supplierOficeId == "") {
              document.getElementById("supplierError").innerHTML = "**Please Select atleast One OfficeId!";
              document.getElementById(`suppliers_Add-Error${i}`).innerHTML = "**Please Select atleast One OfficeId!"
              setTimeout(function () {

                document.getElementById("supplierError").innerHTML = "";
                document.getElementById(`suppliers_Add-Error${i}`).innerHTML = "";
              }
                , 8000);
              return false;
              break;
            }
            for (let k = j + 1; k < this.agencySuppliers[i].supplierBoolean.length; k++) {

              if (this.agencySuppliers[i].supplierBoolean[j].supplierOficeId == this.agencySuppliers[i].supplierBoolean[k].supplierOficeId) {
                document.getElementById("supplierError").innerHTML = "**You Can't Select Same OfficeId in One Supplier";
                document.getElementById(`suppliers_Add-Error${i}`).innerHTML = "**You Can't Select Same OfficeId in One Supplier";
                setTimeout(function () {

                  document.getElementById("supplierError").innerHTML = "";
                  document.getElementById(`suppliers_Add-Error${i}`).innerHTML = "";
                }
                  , 8000);
                return false;
                break;
              }
            }
          }
          this.agencySuppliers[i].createUser = Number(localStorage.getItem("UserId"));
          this.agencySuppliers[i].agency_Branch = this.branchObj.branchId;
        }

        for (let i = 0; i < this.insuranceSuppliers.length; i++) {
          for (let j = 0; j < this.insuranceSuppliers[i].supplierBoolean.length; j++) {
            if (this.insuranceSuppliers[i].supplierBoolean[j].supplierOficeId == null
              || this.insuranceSuppliers[i].supplierBoolean[j].supplierOficeId == undefined
              || this.insuranceSuppliers[i].supplierBoolean[j].supplierOficeId == "") {
              document.getElementById("supplierError").innerHTML = "**Please Select atleast One OfficeId!";
              document.getElementById(`suppliers_Add-Error${i}`).innerHTML = "**Please Select atleast One OfficeId!"
              setTimeout(function () {

                document.getElementById("supplierError").innerHTML = "";
                document.getElementById(`suppliers_Add-Error${i}`).innerHTML = "";
              }
                , 8000);
              return false;
              break;
            }
            for (let k = j + 1; k < this.insuranceSuppliers[i].supplierBoolean.length; k++) {

              if (this.insuranceSuppliers[i].supplierBoolean[j].supplierOficeId == this.insuranceSuppliers[i].supplierBoolean[k].supplierOficeId) {
                document.getElementById("supplierError").innerHTML = "**You Can't Select Same OfficeId in One Supplier";
                document.getElementById(`suppliers_Add-Error${i}`).innerHTML = "**You Can't Select Same OfficeId in One Supplier";
                setTimeout(function () {

                  document.getElementById("supplierError").innerHTML = "";
                  document.getElementById(`suppliers_Add-Error${i}`).innerHTML = "";
                }
                  , 8000);
                return false;
                break;
              }
            }
          }
          this.insuranceSuppliers[i].createUser = Number(localStorage.getItem("UserId"));
          this.insuranceSuppliers[i].agency_Branch = this.branchObj.branchId;
        }
      } else {
        document.getElementById("supplierError").innerHTML = "**Something Went Wrong";
        setTimeout(function () {
          document.getElementById("supplierError").innerHTML = "";
        }
          , 8000);
        return false;

      }
      let supplierslist = JSON.parse(JSON.stringify(this.agencySuppliers)) as SupplierRightsForAgencyAndBranchProperties[];
      for (let k = 0; k < this.insuranceSuppliers.length; k++) {
        supplierslist.push(this.insuranceSuppliers[k]);
      }
      this.branchService.CreateAgencySupplierRights(supplierslist).subscribe((data) => {
        if (data != null && data != false) {
          if (this.branchObj.isAlreadyActive == false) {
            this.branchObj.isAlreadyActive = true;
            this.branchObj.status = true;
          }
          this.router.navigateByUrl("/agencyList")
        }
        else {
          document.getElementById("supplierError").innerHTML = "**Something Went Wrong";
          setTimeout(function () {
            document.getElementById("supplierError").innerHTML = "";
          }
            , 8000);
        }

      })
    }
    catch (e) { }
  }

  checkCreditRight(): boolean {
    let ans = false;
    this.branchService.CheckCreditLimitRightAgaintAgencyAndUserId(localStorage.getItem("AgencyId"), localStorage.getItem("UserId")).subscribe((data) => {

      ans = data

    });
    return ans;
  }

  ReportsagncyCheckboxChange(event) {
    try {
      if (event.target.checked) {
        for (let i = 0; this.reportTypesAgency.length; i++) {
          this.reportTypesAgency[i].status = true;
        }

      }
      else {
        for (let i = 0; this.reportTypesAgency.length; i++) {
          this.reportTypesAgency[i].status = false;
        }

      }
    }
    catch (e) {

    }
  }

  ReportsCheckboxChange(event) {
    try {
      if (event.target.checked) {
        for (let i = 0; this.reportTypesUser.length; i++) {
          this.reportTypesUser[i].status = true;
        }
      }
      else {
        for (let i = 0; this.reportTypesUser.length; i++) {
          this.reportTypesUser[i].status = false;
        }

      }
    }
    catch (e) {

    }

  }
  getReportTypes() {
    this.branchService.GetAllReportTypes().subscribe((data) => {
      this.reportTypesAgency = data;
      let array = [];
      array = data;
      this.reportTypesUser = JSON.parse(JSON.stringify(array));
    })
  }


  /*----------------------------Validation of Branch info page Required----------------------------*/
  ValidationOfBranchInfoPage() {
    try {
      if (this.branchObj.backCompanyId <= 0 || this.branchObj.backCompanyId == undefined || this.branchObj.backCompanyId == null) {
        /*      box input id here*/
        document.getElementById("backCompanyListInput").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelBackCompany").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredBackCompany").innerHTML = "Please Select Company";
        setTimeout(function () {

          document.getElementById("backCompanyListInput").classList.remove("newRequired-BoxColor");
          document.getElementById("labelBackCompany").style.color = "";
          document.getElementById("requiredBackCompany").innerHTML = "";
        }
          , 7000);
        return false;
      }
      if (this.branchObj.maxUsers < 0 || this.branchObj.maxUsers == undefined || this.branchObj.maxUsers == null) {
        /*      box input id here*/
        document.getElementById("tbMaxUsers").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelmaxuser").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredusermax").innerHTML = "Required MaxUsers";
        setTimeout(function () {

          document.getElementById("tbMaxUsers").classList.remove("newRequired-BoxColor");
          document.getElementById("labelmaxuser").style.color = "";
          document.getElementById("requiredusermax").innerHTML = "";
        }
          , 8000);
      }
      if (this.pendingCreditDecreased == true) {

        /*      box input id here*/
        document.getElementById("tbCredit").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelcredit").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredcreditlimit").innerHTML = "You cannot decrease Credit Limit";
        setTimeout(function () {

          document.getElementById("tbCredit").classList.remove("newRequired-BoxColor");
          document.getElementById("labelcredit").style.color = "";
          document.getElementById("requiredcreditlimit").innerHTML = "";
        }
          , 8000);

        return false;
      }
      if (this.branchObj.agencyId == "" || this.branchObj.agencyId == undefined || this.branchObj.agencyId == null) {
        /*      box input id here*/
        document.getElementById("agencyListInput").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelparentagency").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredparentagency").innerHTML = "Required Parent Agency";
        setTimeout(function () {

          document.getElementById("agencyListInput").classList.remove("newRequired-BoxColor");
          document.getElementById("labelparentagency").style.color = "";
          document.getElementById("requiredparentagency").innerHTML = "";
        }
          , 8000);
      }

      if (this.branchObj.branchName == "" || this.branchObj.branchName == undefined || this.branchObj.branchName == null) {
        /*      box input id here*/
        document.getElementById("tbname").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelbranchname").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredbranchname").innerHTML = "Required Branch Name";
        setTimeout(function () {

          document.getElementById("tbname").classList.remove("newRequired-BoxColor");
          document.getElementById("labelbranchname").style.color = "";
          document.getElementById("requiredbranchname").innerHTML = "";
        }
          , 8000);
      }
      if (this.branchObj.notificationEmail == "" || this.branchObj.notificationEmail == undefined || this.branchObj.notificationEmail == null) {
        /*      box input id here*/
        document.getElementById("notifyemail").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelnotifyemail").style.color = "red";
        /*   message id here*/
        document.getElementById("requirednotifyemail").innerHTML = "Required Notify Email";
        setTimeout(function () {

          document.getElementById("notifyemail").classList.remove("newRequired-BoxColor");
          document.getElementById("labelnotifyemail").style.color = "";
          document.getElementById("requirednotifyemail").innerHTML = "";
        }
          , 8000);
      }
      if (this.branchObj.branchEmail == "" || this.branchObj.branchEmail == undefined || this.branchObj.branchEmail == null) {
        /*      box input id here*/
        document.getElementById("tbbranchemail").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelemail").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredemail").innerHTML = "Required Email";
        setTimeout(function () {

          document.getElementById("tbbranchemail").classList.remove("newRequired-BoxColor");
          document.getElementById("labelemail").style.color = "";
          document.getElementById("requiredemail").innerHTML = "";
        }
          , 8000);
      }
      if (this.branchObj.address == "" || this.branchObj.address == undefined || this.branchObj.address == null) {
        /*      box input id here*/
        document.getElementById("tbAddress1").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labeladdress1").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredaddres1").innerHTML = "Required Address";
        setTimeout(function () {

          document.getElementById("tbAddress1").classList.remove("newRequired-BoxColor");
          document.getElementById("labeladdress1").style.color = "";
          document.getElementById("requiredaddres1").innerHTML = "";
        }
          , 8000);
      }

      if (this.branchObj.country == "" || this.branchObj.country == undefined || this.branchObj.country == null) {
        /*      box input id here*/
        document.getElementById("tbCountry").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelcountry").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredcountry").innerHTML = "Required Country";
        setTimeout(function () {

          document.getElementById("tbCountry").classList.remove("newRequired-BoxColor");
          document.getElementById("labelcountry").style.color = "";
          document.getElementById("requiredcountry").innerHTML = "";
        }
          , 8000);
      }
      if (this.branchObj.city == "" || this.branchObj.city == undefined || this.branchObj.city == null) {
        /*      box input id here*/
        document.getElementById("tbCity").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelcity").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredcity").innerHTML = "Required City";
        setTimeout(function () {

          document.getElementById("tbCity").classList.remove("newRequired-BoxColor");
          document.getElementById("labelcity").style.color = "";
          document.getElementById("requiredcity").innerHTML = "";
        }
          , 8000);
      }
      if (this.branchObj.zip == "" || this.branchObj.zip == undefined || this.branchObj.zip == null) {
        /*      box input id here*/
        document.getElementById("tbZip").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelzip").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredzip").innerHTML = "Required Zip";
        setTimeout(function () {

          document.getElementById("tbZip").classList.remove("newRequired-BoxColor");
          document.getElementById("labelzip").style.color = "";
          document.getElementById("requiredzip").innerHTML = "";
        }
          , 8000);
      }
      if (this.branchObj.currencyId == 0 || this.branchObj.currencyId == undefined || this.branchObj.currencyId == null) {
        /*      box input id here*/
        document.getElementById("inputcurrency").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelcurrency").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredcurrency").innerHTML = "Required Currency";
        setTimeout(function () {

          document.getElementById("inputcurrency").classList.remove("newRequired-BoxColor");
          document.getElementById("labelcurrency").style.color = "";
          document.getElementById("requiredcurrency").innerHTML = "";
        }
          , 8000);
      }
      if (this.branchObj.languageId == 0 || this.branchObj.languageId == undefined || this.branchObj.languageId == null) {
        /*      box input id here*/
        document.getElementById("inputlanguage").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labellanguage").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredlanguage").innerHTML = "Required Language";
        setTimeout(function () {

          document.getElementById("inputlanguage").classList.remove("newRequired-BoxColor");
          document.getElementById("labellanguage").style.color = "";
          document.getElementById("requiredlanguage").innerHTML = "";
        }
          , 8000);
      }
      if (this.branchObj.mobile == "" || this.branchObj.mobile == undefined || this.branchObj.mobile == null) {
        /*      box input id here*/
        document.getElementById("tbmobileNo").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelmobile").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredmobile").innerHTML = "Required Mobile";
        setTimeout(function () {

          document.getElementById("tbmobileNo").classList.remove("newRequired-BoxColor");
          document.getElementById("labelmobile").style.color = "";
          document.getElementById("requiredmobile").innerHTML = "";
        }
          , 8000);
      }
      if (this.branchObj.telephone == "" || this.branchObj.telephone == undefined || this.branchObj.telephone == null) {
        /*      box input id here*/
        document.getElementById("tbTelephoneNo").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labetelephone").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredtelephone").innerHTML = "Required Telephone";
        setTimeout(function () {

          document.getElementById("tbTelephoneNo").classList.remove("newRequired-BoxColor");
          document.getElementById("labetelephone").style.color = "";
          document.getElementById("requiredtelephone").innerHTML = "";
        }
          , 8000);
      }
      if (this.settelementCredit && (this.branchObj.creditLimit == 0 || this.branchObj.creditLimit == null)) {
        /*      box input id here*/
        document.getElementById("tbCredit").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelcredit").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredcreditlimit").innerHTML = "Required Credits";
        setTimeout(function () {

          document.getElementById("tbCredit").classList.remove("newRequired-BoxColor");
          document.getElementById("labelcredit").style.color = "";
          document.getElementById("requiredcreditlimit").innerHTML = "";
        }
          , 8000);
        return false;
      }

      if (this.branchObj.agencyId == "" || this.branchObj.agencyId == undefined || this.branchObj.agencyId == null ||
        this.branchObj.branchName == "" || this.branchObj.branchName == undefined || this.branchObj.branchName == null ||
        this.branchObj.notificationEmail == "" || this.branchObj.notificationEmail == undefined || this.branchObj.notificationEmail == null ||
        this.branchObj.branchEmail == "" || this.branchObj.branchEmail == undefined || this.branchObj.branchEmail == null ||
        this.branchObj.address == "" || this.branchObj.address == undefined || this.branchObj.address == null ||

        this.branchObj.country == "" || this.branchObj.country == undefined || this.branchObj.country == null ||
        this.branchObj.city == "" || this.branchObj.city == undefined || this.branchObj.city == null ||
        this.branchObj.zip == "" || this.branchObj.zip == undefined || this.branchObj.zip == null ||
        this.branchObj.currencyId == 0 || this.branchObj.currencyId == undefined || this.branchObj.currencyId == null ||
        this.branchObj.languageId == 0 || this.branchObj.languageId == undefined || this.branchObj.languageId == null ||
        this.branchObj.mobile == "" || this.branchObj.mobile == undefined || this.branchObj.mobile == null ||
        this.branchObj.telephone == "" || this.branchObj.telephone == undefined || this.branchObj.telephone == null

      ) {
        return false;
      }
      if (!this.validateMobileNumber(this.branchObj.mobile)) {
        document.getElementById("tbmobileNo").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelmobile").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredmobile").innerHTML = "Must Start with + sign";
        setTimeout(function () {

          document.getElementById("tbmobileNo").classList.remove("newRequired-BoxColor");
          document.getElementById("labelmobile").style.color = "";
          document.getElementById("requiredmobile").innerHTML = "";
        }
          , 8000);
        return false;
      }
      if (this.branchObj.fax != "") {
        if (!this.validateNumber(this.branchObj.fax)) {
          document.getElementById("tbFax").classList.add("newRequired-BoxColor");
          /*   label id here*/
          document.getElementById("labelfax").style.color = "red";
          /*   message id here*/
          document.getElementById("requiredfax").innerHTML = "Fax Field Must Be a Number";
          setTimeout(function () {

            document.getElementById("tbFax").classList.remove("newRequired-BoxColor");
            document.getElementById("labelfax").style.color = "";
            document.getElementById("requiredfax").innerHTML = "";
          }
            , 8000);
          return false;
        }
      }
      if (this.creditCheck == true) {

        /*      box input id here*/
        document.getElementById("tbCredit").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelcredit").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredcreditlimit").innerHTML = "Credit Should less from Parent";
        setTimeout(function () {

          document.getElementById("tbCredit").classList.remove("newRequired-BoxColor");
          document.getElementById("labelcredit").style.color = "";
          document.getElementById("requiredcreditlimit").innerHTML = "";
        }
          , 8000);
        return false;
      }
      if (!this.validateEmail(this.branchObj.branchEmail)) {
        // this.emailValid.focus();
        /*      box input id here*/
        document.getElementById("tbAgencyemail").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelemail").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredemail").innerHTML = "Email Pattern Must Be True";
        setTimeout(function () {

          document.getElementById("tbAgencyemail").classList.remove("newRequired-BoxColor");
          document.getElementById("labelemail").style.color = "";
          document.getElementById("requiredemail").innerHTML = "";
        }
          , 8000);

        return false;
      }
      //14-june-23
      if (this.branchObj.maximumChildAgencies < 0 || this.branchObj.maximumChildAgencies == undefined || this.branchObj.maximumChildAgencies == null) {
        /*      box input id here*/
        document.getElementById("tbMaxChildAgency").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelmaxAgency").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredAgencymax").innerHTML = "Should not be Empty or greater Than Equal 0";
        setTimeout(function () {

          document.getElementById("tbMaxChildAgency").classList.remove("newRequired-BoxColor");
          document.getElementById("labelmaxAgency").style.color = "";
          document.getElementById("requiredAgencymax").innerHTML = "";
        }
          , 8000);
        return false;
      }
      if (this.branchObj.maximumChildBranches < 0 || this.branchObj.maximumChildBranches == undefined || this.branchObj.maximumChildBranches == null) {
        /*      box input id here*/
        document.getElementById("tbMaxChildBranch").classList.add("newRequired-BoxColor");
        /*   label id here*/
        document.getElementById("labelmaxbranch").style.color = "red";
        /*   message id here*/
        document.getElementById("requiredbranchmax").innerHTML = "Should not be Empty or greater Than Equal 0";
        setTimeout(function () {

          document.getElementById("tbMaxChildbranch").classList.remove("newRequired-BoxColor");
          document.getElementById("labelmaxbranch").style.color = "";
          document.getElementById("requiredbranchmax").innerHTML = "";
        }
          , 8000);
        return false;
      }
      else {
        return true;
      }

    }
    catch (e) {

    }



  }

  /*  shoaib editing */
  /*--------------------------- agency branch save here this two function--------------------------*/
  branchInfoClick = (req: string): boolean => {

    try {
      if (!this.ValidationOfBranchInfoPage()) {
        return;
      }
      if (this.userlimitreached == true) {
        return;
      }

      if (this.branchObj.immediateParent == null || this.branchObj.immediateParent == "") {
        this.branchObj.immediateParent = this.branchObj.agencyId;
      }

      try {
        this.branchObj.branchColourCode= this.branchColor; 
        let flag = false;
        let userId = 0;
        if (localStorage.getItem("UserId") != undefined && localStorage.getItem("UserId") != null) {
          userId = Number(localStorage.getItem("UserId"))
          if (userId != 0) {
            /*--------------------------create call of new branch--------------------*/
            if (this.branchObj.branchId == "" || this.branchObj.branchId == undefined) {
              this.CheckChildBranchesLimit().subscribe((r) => {
                if (r == true) {
                  this.branchObj.creationUser = userId;
                  /* this.branchObj.userObj.reportTypesRightsUser = this.reportTypesUser;*/
                  this.branchService.AddNewBranch(this.branchObj).subscribe((data) => {
                    if (data.isSave == true) {
                      this.branchObj.branchId = data.branchId;
                      this.creationBranch = this.branchObj.branchId;
                      flag = true;
                      if (this.agencyAG01 == "AG01") {
                        this.branchInfoComplete = false;
                        this.BackOfficeInfoComplete = true;
                        this.stepTwo = true;
                      }
                      else {
                        this.branchInfoComplete = false;
                        this.BackOfficeInfoComplete = false;
                        this.stepTwo = false;
                        this.agencyRightsComplete = true;
                        this.stepThree = true;
                      }

                      if (this.branchObj.branchId.includes("AG01")) {
                        this.selectMultipleBackSystemCustomer = true;
                      }
                      else {
                        this.selectMultipleBackSystemCustomer = false;
                      }
                      if (this.branchObj.immediateParent != "AG01") {
                        this.backsystemgetinfo(this.branchObj.immediateParent);
                      }

                      this.currencyCodeList$.subscribe(data => {
                        const currencyList = data.find(id => id.currencyId === this.branchObj.currencyId);
                        const comapnyList = this.backSystemCompanies.filter(company =>
                          currencyList.currencyName.includes(company.companyCurrency));
                        this.backSystemCompanies = comapnyList;

                      });

                      //subject.next(flag);
                    }
                    else {
                      flag = false;
                      //subject.next(flag);
                      $("#lblerrormsg").show();
                      document.getElementById("lblerrormsg").innerHTML = "Something went wrong on Creating Branch."
                      $("#lblerrormsg").delay(5000).hide(10);
                    }
                  });
                  return flag;
                }
              })
            }
            /*------------------------------------ update call of branch-----------------------------*/
            else {
              this.branchObj.modifyUser = userId;
              /*this.branchObj.userObj.reportTypesRightsUser = this.reportTypesUser;*/
              this.branchService.UpdateBranch(this.branchObj).subscribe((data) => {
                if (data == true) {
                  this.backsystemgetinfo(this.branchObj.branchId);
                  if (this.branchObj.branchId.includes("AG01")) {
                    this.selectMultipleBackSystemCustomer = true;
                  }
                  else {
                    this.selectMultipleBackSystemCustomer = false;
                  }
                  this.currencyCodeList$.subscribe(data => {
                    const currencyList = data.find(id => id.currencyId === this.branchObj.currencyId);
                    const comapnyList = this.backSystemCompanies.filter(company =>
                      currencyList.currencyName.includes(company.companyCurrency));
                    this.backSystemCompanies = comapnyList;

                  });

                  if (this.agencyAG01 == "AG01") {
                    this.branchInfoComplete = false;
                    this.BackOfficeInfoComplete = true;
                    this.stepTwo = true;
                  }
                  else {
                    this.branchInfoComplete = false;
                    this.BackOfficeInfoComplete = false;
                    this.stepTwo = false;
                    this.agencyRightsComplete = true;
                    this.stepThree = true;
                  }
                  if (this.branchObj.immediateParent != "AG01") {
                    this.backsystemgetinfo(this.branchObj.immediateParent);
                  }

                  flag = true;
                }
                else {
                  flag = false;
                  $("#lblerrormsg").show();
                  document.getElementById("lblerrormsg").innerHTML = "Something went wrong on Updating Branch."
                  $("#lblerrormsg").delay(5000).hide(10);
                }
              });
              //return subject.asObservable();
            }
          }

          if (req === 'save') {
            this.router.navigateByUrl("/flightSearch")
          }

        }
      } catch (e) {
        console.log(e);
      }
    }
    catch (e) { console.log(e) }
  }
  /*----------------------Back system office procedure start here------------------------------*/
  OnCustomerCodeChange = (customerCode: string, index: number): void => {
    this.backsystemOfficeProperties[index].backSystemCompanyCustomer = [];
    this.backsystemOfficeProperties[index].backSystemCompanyCustomer.push(customerCode);

  }
  GetParentBackSystemCompanies = (parentId: string): void => {
    this.branchService.GetParentBackSystemCompanies(parentId).subscribe(data => {
      this.backsystemParentCompanies = data;
      const backCompanies = this.backSystemCompanies.filter(company => company.companyId === this.backsystemParentCompanies.backSystemCompanyId);
      this.backSystemCompanies = backCompanies;
      // console.log(this.backsystemOfficeProperties)
      for (let i = 0; i < this.backsystemOfficeProperties.length; i++) {
        // console.log(this.backsystemOfficeProperties[i].customerCodesList)
        const backCustomer = this.backsystemOfficeProperties[i].customerCodesList.filter(customer =>
          customer.customerCode === this.backsystemParentCompanies.backSystemCustomerCode);
        this.backsystemOfficeProperties[i].customerCodesList = backCustomer
        // console.log(backCustomer);
      };
    })

  }
  backsystemgetinfo = (branch: string): void => {
    this.branchService.GetBackSystemByid(branch).subscribe((data) => {
      if (data.length > 0) {
        this.backSystemAllList = [];
        this.backSystemCompanyIds = []
        this.backSystemAllList = data;
        this.backSystemAllList.forEach((item, index: number) => {
          let back = new BackSystemOfficeProperties()
          back.backSystemCompanyId = item.backSystemCompanyId;
          back.agecnyBranchID = item.agecnyBranchID;
          if (item.backSystemCompanyId != 0 && item.backSystemCompanyId != null && item.backSystemCompanyId != undefined) {
            let companyURL = "";
            for (let i = 0; i < this.backSystemCompanies.length; i++) {
              if (item.backSystemCompanyId == this.backSystemCompanies[i].companyId) {
                companyURL = this.backSystemCompanies[i].companyURL;
                this.loaderVar = true;
                break;
              }

            }
            var req = new UrlRequest();
            req.request = companyURL;
            this.branchService.GetCustomerCodeByID(req).subscribe((data) => {
              this.backsystemOfficeProperties[index].customerCodesList = data
              this.loaderVar = false;
            });
          }

          item.backSystemAll.forEach((c) => {
            back.backSystemCompanyCustomer.push(c.backSystemCompanyCustomer);
          });
          this.backsystemOfficeProperties.push(back);
          let companyName = new BackSystemCompanyId();
          companyName.backSystemCompanyId = item.backSystemCompanyId;
          this.backSystemCompanyIds.push(companyName);
        });
        if (this.branchObj.branchId != "AG01") {
          for (let index = 0; index < this.backsystemOfficeProperties.length; index++) {
            this.backsystemOfficeProperties[index].selectSingleBackSystemCustomer = this.backsystemOfficeProperties[index].backSystemCompanyCustomer[0];
          }
        }
        if (this.branchObj.immediateParent != "AG01") {
          setTimeout(() => {
            this.GetParentBackSystemCompanies(this.branchObj.immediateParent);
          }, 500)
        }
        this.backSystemCompaniesForAdminInfo = [];
        for (let i = 0; i < this.backSystemCompanyIds.length; i++) {
          for (let j = 0; j < this.backSystemCompanies.length; j++) {
            if (this.backSystemCompanies[j].companyId == this.backSystemCompanyIds[i].backSystemCompanyId) {
              let backSystem = new CompanyMasterProperties();
              backSystem.companyId = this.backSystemCompanies[j].companyId;
              backSystem.companyName = this.backSystemCompanies[j].companyName;
              this.backSystemCompaniesForAdminInfo.push(backSystem);
              break;
            }
          }
        }
        for (let j = 0; j < this.backSystemCompaniesForAdminInfo.length; j++) {
          if (this.backSystemCompaniesForAdminInfo[j].companyId == this.branchObj.userObj.backSystemCompanyId) {
            this.GetSelectedBackSystemCustomers(this.branchObj.userObj.backSystemCompanyId);
            break;
          }
        }
      }
    });
  }
  backSystemInfoSave = (req: string): boolean => {
    let branchId = this.branchObj.branchId;
    if (this.backsystemOfficeProperties.length > 0) {
      for (let i = 0; i < this.backsystemOfficeProperties.length; i++) {
        if (this.backsystemOfficeProperties[i].backSystemCompanyId == null || this.backsystemOfficeProperties[i].backSystemCompanyId == 0 || this.backsystemOfficeProperties[i].backSystemCompanyId == undefined) {
          /*      box input id here*/
          document.getElementById("Back_System_Companies" + i).classList.add("newRequired-BoxColor");
          /*   label id here*/
          document.getElementById("Back_System_CompaniesLabel" + i).style.color = "red";
          /*   message id here*/
          document.getElementById("Back_System_CompaniesError" + i).innerHTML = "Please Select Back System Company";
          setTimeout(function () {

            document.getElementById("Back_System_Companies" + i).classList.remove("newRequired-BoxColor");
            document.getElementById("Back_System_CompaniesLabel" + i).style.color = "";
            document.getElementById("Back_System_CompaniesError" + i).innerHTML = "";
          }
            , 8000);
          return false;
        }
        if (this.backsystemOfficeProperties[i].backSystemCompanyCustomer == null || this.backsystemOfficeProperties[i].backSystemCompanyCustomer.length == 0) {
          /*      box input id here*/
          document.getElementById("Customer_Code" + i).classList.add("newRequired-BoxColor");
          /*   label id here*/
          document.getElementById("Customer_CodeLabel" + i).style.color = "red";
          /*   message id here*/
          document.getElementById("Customer_CodeError" + i).innerHTML = "Please Select Customer Code";
          setTimeout(function () {

            document.getElementById("Customer_Code" + i).classList.remove("newRequired-BoxColor");
            document.getElementById("Customer_CodeLabel" + i).style.color = "";
            document.getElementById("Customer_CodeError" + i).innerHTML = "";
          }
            , 8000);
          return false;
        }

        if (branchId != undefined) {
          this.backsystemOfficeProperties[i].agecnyBranchID = branchId;
        }

      }
      for (let j = 0; j < this.backsystemOfficeProperties.length; j++) {
        for (let k = j + 1; k < this.backsystemOfficeProperties.length; k++) {
          if (this.backsystemOfficeProperties[j].backSystemCompanyId == this.backsystemOfficeProperties[k].backSystemCompanyId) {
            document.getElementById("backSystemInfoError").innerHTML = "**You Can't Select One Company Twice or More";
            setTimeout(function () {

              document.getElementById("backSystemInfoError").innerHTML = "";
            }
              , 8000);
            return false;
          }
        }
        for (let l = 0; l < this.backsystemOfficeProperties[j].backSystemCompanyCustomer.length; l++) {
          if (this.backsystemOfficeProperties[j].backSystemCompanyCustomer[l] == null) {
            document.getElementById("Customer_Code" + l).classList.add("newRequired-BoxColor");
            /*   label id here*/
            document.getElementById("Customer_CodeLabel" + l).style.color = "red";
            /*   message id here*/
            document.getElementById("Customer_CodeError" + l).innerHTML = "Please Select Customer Code";
            setTimeout(function () {

              document.getElementById("Customer_Code" + l).classList.remove("newRequired-BoxColor");
              document.getElementById("Customer_CodeLabel" + l).style.color = "";
              document.getElementById("Customer_CodeError" + l).innerHTML = "";
            }
              , 8000);
            return false;
          }
        }
      }
      this.backsystemOfficeProperties = this.backsystemOfficeProperties.map(data => {
        return { ...data, agecnyBranchIDParent: this.branchObj.immediateParent }
      });
      this.branchService.CreateBackSystemInfo(this.backsystemOfficeProperties).subscribe((data) => {
        if (data.isSave != false) {
          // if (this.branchObj.branchId != "AG01") {
          //   this.branchObj.userObj.backSystemCompanyCustomer = this.backsystemOfficeProperties[0].selectSingleBackSystemCustomer
          //   this.branchObj.userObj.backSystemCompanyId = this.backsystemOfficeProperties[0].backSystemCompanyId;
          // }
          this.BackOfficeInfoComplete = false;
          this.agencyRightsComplete = true;
          this.stepThree = true;


        }
        else {

          $("#lblerrormsg").show();
          document.getElementById("lblerrormsg").innerHTML = "Something went wrong."
          $("#lblerrormsg").delay(5000).hide(10);
        }
      });

    }
    else {

      $("#lblerrormsg").show();
      document.getElementById("lblerrormsg").innerHTML = "Please Select Atleast One company!";
      $("#lblerrormsg").delay(5000).hide(10);
      // this.BackOfficeInfoComplete = false;
      // this.agencyRightsComplete = true;
      // this.stepThree = true;
    }
    if (req === 'save') {
      this.router.navigateByUrl("/flightSearch")
    }
    else {
      this.branchService.AgencyBranchLimitationRights(this.branchObj.branchId).subscribe((data) => {
        this.AgencyBranchLimitationRights = data;
      });
    }

  }
  addBackOffice = (): void => {
    try {
      if (this.selectMultipleBackSystemCustomer == true) {
        let obj = new BackSystemOfficeProperties();
        this.backsystemOfficeProperties.push(obj);
      }
      else {
        if (this.backsystemOfficeProperties.length == 0) {
          let obj = new BackSystemOfficeProperties();
          this.backsystemOfficeProperties.push(obj);
        }
        else {
          document.getElementById("backSystemInfoError").innerHTML = "**You Can Only Add One Company";
          setTimeout(function () {

            document.getElementById("backSystemInfoError").innerHTML = "";
          }
            , 8000);
        }
      }
    }
    catch (e) {
      console.log(e);
    }
  }
  removeBackOffice(i) {
    try {
      this.backsystemOfficeProperties.splice(i, 1);
    } catch (e) {
      console.log(e);
    }
  }
  GetBackSystemCustomers = (companyId: number, index): void => {

    if (companyId != 0 && companyId != null && companyId != undefined) {
      let companyURL = "";
      for (let i = 0; i < this.backSystemCompanies.length; i++) {
        if (companyId == this.backSystemCompanies[i].companyId) {
          companyURL = this.backSystemCompanies[i].companyURL;
          this.loaderVar = true;
          break;
        }

      }
      var req = new UrlRequest();
      req.request = companyURL;
      this.branchService.GetCustomerCodeByID(req).subscribe((data) => {
        this.backsystemOfficeProperties[index].customerCodesList = data
        this.loaderVar = false;
        if (this.branchObj.immediateParent != "AG01") {
          const backCustomer = this.backsystemOfficeProperties[index].customerCodesList.filter(customer =>
            customer.customerCode === this.backsystemParentCompanies.backSystemCustomerCode);
          this.backsystemOfficeProperties[index].customerCodesList = backCustomer;
        }
      });
    }


  }

  /*--------------------------- managers save update rights assign here this three function--------------------------*/
  managerInfoClick = (req: string): boolean => {
    //console.log(localStorage.getItem("AgencyId"));
    //console.log(localStorage.getItem("ParentAgency"));
    try {
      this.CheckManagerValiations();
      for (let k = 0; k < this.managerList.length; k++) {
        if (this.managerList[k].userId <= 0 || this.managerList[k].userId == undefined || this.managerList[k].userId == null
          || this.managerList[k].managerEmailAddress == null || this.managerList[k].managerEmailAddress == undefined || this.managerList[k].managerEmailAddress == ""
          || this.managerList[k].managerPhone == undefined || this.managerList[k].managerPhone == "" || this.managerList[k].managerPhone == null) {
          return;
        }

        if (!this.validateEmail(this.managerList[k].managerEmailAddress)) {
          document.getElementById(`tbmanagerEmail${k}`).classList.add("newRequired-BoxColor");
          /*   label id here*/
          document.getElementById(`labelmanagerEmail${k}`).style.color = "red";
          /*   message id here*/
          document.getElementById(`requiredmanagerEmail${k}`).innerHTML = "Email Pattern Must be Followed";
          setTimeout(function () {

            document.getElementById(`tbmanagerEmail${k}`).classList.remove("newRequired-BoxColor");
            document.getElementById(`labelmanagerEmail${k}`).style.color = "";
            document.getElementById(`requiredmanagerEmail${k}`).innerHTML = "";
          }
            , 8000);
          return;
        }
        if (!this.validateMobileNumber(this.managerList[k].managerPhone)) {
          document.getElementById(`tbManagerPhone${k}`).classList.add("newRequired-BoxColor");
          /*   label id here*/
          document.getElementById(`labelManagerPhone${k}`).style.color = "red";
          /*   message id here*/
          document.getElementById(`requiredManagerPhone${k}`).innerHTML = "Must Start with + sign";
          setTimeout(function () {

            document.getElementById(`tbManagerPhone${k}`).classList.remove("newRequired-BoxColor");
            document.getElementById(`labelManagerPhone${k}`).style.color = "";
            document.getElementById(`requiredManagerPhone${k}`).innerHTML = "";
          }
            , 8000);
          return;
        }
      }
      this.branchObj.managers = [];

      for (let k = 0; k < this.managerList.length; k++) {
        let list = this.managerList[k] as ManagerProperties;

        if (list.userId != 0 && list.managerName != "") {
          this.branchObj.managers.push(list);
        }
      }
      if (this.ParentManagerValidation() == false) {
        document.getElementById("managerInfoError").innerHTML = "**Please Select atleast One Parent Agency Managers";
        setTimeout(() => {
          document.getElementById("managerInfoError").innerHTML = "";
        }, 5000);
        return;
      }
      this.branchService.CreateUpdateManagers(this.branchObj).subscribe((data) => {
        if (data.isSave == true) {
          this.branchObj.managers = data.managers;
          this.GetparentAgencyRights();
          this.managerInfoComplete = false;
          this.supplierRightsComplete = true;
          this.stepSix = true;
          this.GetSuppliersByParent();
        }
        else {
          console.log(data.message);
          $("#lblerrormsg").show();
          document.getElementById("lblerrormsg").innerHTML = "Something went wrong On Create & Update Managers."
          $("#lblerrormsg").delay(5000).hide(10);
        }
      });
      if (req === 'save') {
        this.router.navigateByUrl("/flightSearch");
      }

    } catch (e) { console.log(e) }
  }

  CheckManagerValiations(): boolean {
    try {
      if (this.managerList.length > 0) {
        for (let k = 0; k < this.managerList.length; k++) {
          let list = this.managerList[k];
          if (list.userId <= 0 || list.userId == undefined || list.userId == null) {
            document.getElementById(`managerNameInput${k}`).classList.add("newRequired-BoxColor");
            /*   label id here*/
            document.getElementById(`labelManagerName${k}`).style.color = "red";
            /*   message id here*/
            document.getElementById(`requiredManagerName${k}`).innerHTML = "Required Manager";
            setTimeout(function () {

              document.getElementById(`managerNameInput${k}`).classList.remove("newRequired-BoxColor");
              document.getElementById(`labelManagerName${k}`).style.color = "";
              document.getElementById(`requiredManagerName${k}`).innerHTML = "";
            }
              , 8000);
            return;

          }
          if (list.managerEmailAddress == null || list.managerEmailAddress == undefined || list.managerEmailAddress == "") {
            document.getElementById(`tbmanagerEmail${k}`).classList.add("newRequired-BoxColor");
            /*   label id here*/
            document.getElementById(`labelmanagerEmail${k}`).style.color = "red";
            /*   message id here*/
            document.getElementById(`requiredmanagerEmail${k}`).innerHTML = "Email Required";
            setTimeout(function () {

              document.getElementById(`tbmanagerEmail${k}`).classList.remove("newRequired-BoxColor");
              document.getElementById(`labelmanagerEmail${k}`).style.color = "";
              document.getElementById(`requiredmanagerEmail${k}`).innerHTML = "";
            }
              , 8000);
            return;

          }
          if (list.managerPhone == undefined || list.managerPhone == "" || list.managerPhone == null) {
            document.getElementById(`tbManagerPhone${k}`).classList.add("newRequired-BoxColor");
            /*   label id here*/
            document.getElementById(`labelManagerPhone${k}`).style.color = "red";
            /*   message id here*/
            document.getElementById(`requiredManagerPhone${k}`).innerHTML = "Required Mobile No";
            setTimeout(function () {

              document.getElementById(`tbManagerPhone${k}`).classList.remove("newRequired-BoxColor");
              document.getElementById(`labelManagerPhone${k}`).style.color = "";
              document.getElementById(`requiredManagerPhone${k}`).innerHTML = "";
            }
              , 8000);
            return;

          }
        }

      }
    }
    catch (e) {
      console.log(e);
    }
  }
  removeManager(i) {
    try {
      this.loaderVar = true;
      if (this.managerList[i].managerId != 0) {
        this.branchService.DeleteManager(this.managerList[i].managerId).subscribe(data => {
          if (data == true) {
            this.managerList.splice(i, 1);
            this.loaderVar = false;
          }
          else {
            this.loaderVar = false;

            document.getElementById("ManagerDetailsBtn").removeAttribute('disabled');
            document.getElementById("ManagerDetailsBtn").style.background = "";
            document.getElementById("ManagerDetailsBackBtn").style.display = "block";
          }

        })
      }
      else {
        if (this.managerList[i].managerId == 0) {
          this.managerList.splice(i, 1);
          document.getElementById("ManagerDetailsBtn").removeAttribute('disabled');
          document.getElementById("ManagerDetailsBtn").style.background = "";
          document.getElementById("ManagerDetailsBackBtn").style.display = "block";
        }
        this.loaderVar = false;
      }

    } catch (e) {
      console.log(e);
    }
  }
  //end
  AddManager() {
    try {
      let obj = new ManagerProperties();
      this.managerList.push(obj);
    } catch (e) {
      console.log(e);
    }
  }
  adminrightifagencynot() {
    if (this.branchObj.agencyRightObj.profileUpdate == false) {
      this.branchObj.userObj.adminUser.profileUpdate = false;
    }
    if (this.branchObj.agencyRightObj.beneficiaryAccount == false) {
      this.branchObj.userObj.adminUser.beneficiaryAccount = false;
    }
    if (this.branchObj.agencyRightObj.paymentProcess == false) {
      this.branchObj.userObj.adminUser.paymentProcess = false;
      this.branchObj.userObj.adminUser.addPayment = false;
      this.branchObj.userObj.adminUser.approvePayment = false;
    }

    if (this.branchObj.agencyRightObj.creditLimit == false) {
      this.branchObj.userObj.adminUser.creditLimit = false;
    }
    if (this.branchObj.agencyRightObj.notifications == false) {
      this.branchObj.userObj.adminUser.notifications = false;
    }
    if (this.branchObj.agencyRightObj.revenueManagement == false) {
      this.branchObj.userObj.adminUser.revenueManagement = false;
    }
    if (this.branchObj.agencyRightObj.reportsManagement == false) {
      this.branchObj.userObj.adminUser.reportsManage = false;
      for (let o = 0; o < this.reportTypesUser.length; o++) {
        this.reportTypesUser[o].status = false;
      }

    }
    if (this.branchObj.agencyRightObj.offlineRequest == false) {
      this.branchObj.userObj.adminUser.offlineRequest = false;
      this.branchObj.userObj.adminUser.offlineBooking = false;
      this.branchObj.userObj.adminUser.offlineDealsByCMS = false;
      this.branchObj.userObj.adminUser.offlineRefund = false;
      this.branchObj.userObj.adminUser.offlineTicket = false;
      this.branchObj.userObj.adminUser.offlineVoid = false;
    }
    if (this.branchObj.agencyRightObj.offlineSettings == false) {
      this.branchObj.userObj.adminUser.offlineSettings = false;
    }
    if (this.branchObj.agencyRightObj.supplierManagement == false) {
      this.branchObj.userObj.adminUser.supplierManagement = false;
    }
    if (this.branchObj.agencyRightObj.accountManagement == false) {
      this.branchObj.userObj.adminUser.accountManagement = false;
      this.branchObj.userObj.adminUser.agencyManagement = false;
      this.branchObj.userObj.adminUser.branchManagement = false;
      this.branchObj.userObj.adminUser.account = false;
      this.branchObj.userObj.adminUser.users = false;
      this.branchObj.userObj.adminUser.logs = false;
      this.branchObj.userObj.adminUser.currency = false;
    }
    if (this.branchObj.agencyRightObj.bookings == false) {
      this.branchObj.userObj.adminUser.bookings = false;
      this.branchObj.userObj.adminUser.searchBookings = false;
      this.branchObj.userObj.adminUser.viewBookings = false;
      this.branchObj.userObj.adminUser.viewSubAgentBookings = false;
      this.branchObj.userObj.adminUser.issueTicket = false;
      this.branchObj.userObj.adminUser.cancelPNR = false;
      this.branchObj.userObj.adminUser.refund = false;
      this.branchObj.userObj.adminUser.importPNR = false;
      this.branchObj.userObj.adminUser.exchangeTicket = false;
      this.branchObj.userObj.adminUser.quotations = false;
      this.branchObj.userObj.adminUser.fareRules = false;
      this.branchObj.userObj.adminUser.voidTicket = false;
    }
    if (this.branchObj.agencyRightObj.cms == false) {
      this.branchObj.userObj.adminUser.cms = false;
    }
    if (this.branchObj.agencyRightObj.dashboard == false) {
      this.branchObj.userObj.adminUser.dashboard = false;
    }
    if (this.branchObj.agencyRightObj.currency == false) {
      this.branchObj.userObj.adminUser.currency = false;
    }

    if (this.branchObj.agencyRightObj.accountManagement == false) {
      this.branchObj.userObj.adminUser.accountManagement = false;
      this.branchObj.userObj.adminUser.users = false;
      this.branchObj.userObj.adminUser.account = false;
      this.branchObj.userObj.adminUser.agencyManagement = false;
      this.branchObj.userObj.adminUser.branchManagement = false;

    }
    if (this.branchObj.agencyRightObj.users == false) {
      this.branchObj.userObj.adminUser.users = false;


    }
    if (this.branchObj.agencyRightObj.agencyManagement == false) {
      this.branchObj.userObj.adminUser.agencyManagement = false;
    }
    if (this.branchObj.agencyRightObj.account == false) {
      this.branchObj.userObj.adminUser.account = false;
    }
    if (this.branchObj.agencyRightObj.branchManagement == false) {
      this.branchObj.userObj.adminUser.branchManagement = false;

    }
    if (this.branchObj.agencyRightObj.companyMasterRight == false) {
      this.branchObj.userObj.adminUser.companyMasterRight = false;
    }
  }
  /*--------------------------- agency branch rights assign here this two function--------------------------*/
  AgencyRightsClick = (req: string): boolean => {
    try {
      if (this.branchObj.maximumChildBranches > 0) {

        if (this.branchObj.agencyRightObj.issueTicket == false) {
          document.getElementById("AgencyRightError").innerHTML = "**Please Give Ticket Issuance Rights";
          setTimeout(() => {
            document.getElementById("AgencyRightError").innerHTML = "";
          }, 5000);
          return;
        }
      }
      let userId = 0;
      if (localStorage.getItem("UserId") != undefined && localStorage.getItem("UserId") != null) {
        userId = Number(localStorage.getItem("UserId"))
        if (userId != 0) {

          if (this.branchObj.branchId != "" && this.branchObj.branchId != undefined) {
            this.branchObj.agencyRightObj.agencyId = this.branchObj.branchId;
            if (this.branchObj.agencyRightObj.agencyRightId == 0 || this.branchObj.userObj.userId == null) {
              this.branchObj.agencyRightObj.creationUser = userId;
              this.branchObj.agencyRightObj.reportTypesRights = this.reportTypesAgency;
              this.branchService.CreateAgencyRights(this.branchObj.agencyRightObj).subscribe((data) => {
                if (data.isSave == true) {

                  this.reportTypesAgency = data.reportTypesRights
                  for (let k = 0; k < this.reportTypesAgency.length; k++) {
                    for (let j = 0; j < this.reportTypesUser.length; j++) {
                      if (this.reportTypesUser[j].reportTypes == this.reportTypesAgency[k].reportTypes) {
                        this.reportTypesUser[j].statusForUser = this.reportTypesAgency[k].status;
                        this.reportTypesUser[j].status = this.reportTypesAgency[k].status;
                      }
                    }
                  }
                  this.GetparentAgencyRights();
                  this.adminrightifagencynot();
                  this.agencyRightsComplete = false;
                  this.adminInfoComplete = true;
                  this.stepFour = true;
                }
                else {
                  this.branchObj.agencyRightObj.agencyRightId = 0;
                  $("#lblerrormsg").show();
                  document.getElementById("lblerrormsg").innerHTML = "Something went wrong."
                  $("#lblerrormsg").delay(5000).hide(10);
                }
              });
            }
            else {
              this.branchObj.agencyRightObj.modifyUser = userId;
              this.branchObj.agencyRightObj.reportTypesRights = this.reportTypesAgency;
              this.branchService.UpdateAgencyRights(this.branchObj.agencyRightObj).subscribe((data) => {
                if (data.isSave == true) {

                  this.reportTypesAgency = data.reportTypesRights
                  for (let k = 0; k < this.reportTypesAgency.length; k++) {
                    for (let j = 0; j < this.reportTypesUser.length; j++) {
                      if (this.reportTypesUser[j].reportTypes == this.reportTypesAgency[k].reportTypes) {
                        this.reportTypesUser[j].statusForUser = this.reportTypesAgency[k].status;
                        this.reportTypesUser[j].status = this.reportTypesAgency[k].status;
                      }
                    }
                  }
                  this.GetparentAgencyRights();
                  this.adminrightifagencynot();
                  this.agencyRightsComplete = false;
                  this.adminInfoComplete = true;
                  this.stepFour = true;
                }
                else {
                  this.branchObj.agencyRightObj.agencyRightId = 0;
                  $("#lblerrormsg").show();
                  document.getElementById("lblerrormsg").innerHTML = "Something went wrong."
                  $("#lblerrormsg").delay(5000).hide(10);
                }
              });
            }
            this.backsystemgetinfo(this.branchObj.branchId);
          }
        }
        if (this.branchObj.immediateParent != "AG01") {
          this.backsystemOfficeProperties[0].selectSingleBackSystemCustomer = this.backsystemOfficeProperties[0].customerCodesList[0].customerCode
          this.backsystemOfficeProperties[0].backSystemCompanyId = this.backSystemCompanies[0].companyId
          this.backSystemInfoSave('Next Step');
          this.agencyRightsComplete = false;
          this.adminInfoComplete = true;
          this.stepFour = true;
        }

        if (req === 'save') {
          this.router.navigateByUrl("/flightSearch")
        }
      }
    }
    catch (e) {
      console.log(e);
    }
    //}
  }
  /*----------------------adminuserRight procedure start here------------------------------*/
  
  /* ----------------------------------- other function--------------------------*/
  colorarray = ['#0081AB', '#299617', '#C46210', '#2243B6', '#5DADEC', '#5946B2', '#A83731', '#9C51B6', '#AF6E4D', '#1B1B1B', '#FF5470', '#FF7A00', '#87FF2A', '#0048BA', '#9FE2BF', '#6495ED',
    '#FFAA1D', '#299617', '#FFF700', '#2243B6', '#5DADEC', '#5946B2', '#A83731', '#9C51B6', '#AF6E4D', '#1B1B1B', '#FF5470', '#FF7A00', '#87FF2A', '#0048BA', '#9FE2BF', '#6495ED'];
  showadminInfoPassowrd() {
    var x = document.getElementById("tbpassword") as HTMLInputElement;

    if (x.type === "password") {
      x.type = "text";
      document.getElementById("togglePassword").classList.toggle("fa-eye");
      document.getElementById("togglePassword").classList.remove("fa-eye-slash");
    } else {
      x.type = "password";
      document.getElementById("togglePassword").classList.add("fa-eye-slash");
      document.getElementById("togglePassword").classList.remove("fa-eye");
    }
  }
  RadioSettleMentCheck(e) {
    try {
      if (e.target.value == "Cash") {
        var cash = document.querySelector("#tbCredit") as HTMLInputElement;
        cash.value = String(0);
        this.settelementCash = true;
        this.settelementCredit = false;
        this.branchObj.settlementMode = 1;
        this.creditReadOnly = true;
        this.branchObj.creditLimit = 0;
        this.creditCheck = false;

        this.pendingCreditDecreased = false;
      }
      else if (e.target.value == "Credit") {
        var credit = document.querySelector("#tbCredit") as HTMLInputElement;
        credit.value = String(this.branchObj.creditLimit);
        this.settelementCredit = true;
        this.settelementCash = false;
        this.branchObj.settlementMode = 2;
        this.creditReadOnly = false;

      }
    }
    catch (e) {

    }
  }

  GetparentAgencyRights() {
    try {
      let param = "";
      let isAgency;
      if (this.branchObj.immediateParent == "" || this.branchObj.immediateParent == null
        /*|| this.branchObj.immediateParent == this.branchObj.agencyId*/) {
        isAgency = true;
      }
      else
        isAgency = false;
      if (isAgency == true)
        param = this.branchObj.agencyId;
      else
        param = this.branchObj.branchId;
      if (param != "") {
        this.branchService.GetparentAgencyRights(param, this.branchObj.userObj.userId).subscribe((data) => {
          let rightsObj = new AgencyRightsProperties;
          this.userRightDisable = new UserRightsDisabledProperties();
          rightsObj = (data);

          if (rightsObj != null) {
            if (rightsObj.reportUserRights != null) {
              for (let i = 0; i < rightsObj.reportUserRights.length; i++) {

                for (let j = 0; j < this.reportTypesUser.length; j++) {
                  if (this.reportTypesUser[j].reportTypes == rightsObj.reportUserRights[i].reportTypeName) {

                    this.reportTypesUser[j].reportRightId = rightsObj.reportUserRights[i].reportAgencyRightId;
                    this.reportTypesUser[j].status = rightsObj.reportUserRights[i].status;

                  }

                }
              }
            }
            if (rightsObj.profileUpdate == false) {
              // this.agr_profileDisabled = true;
              this.userRightDisable.ad_profileDisbled = true;
              this.branchObj.userObj.adminUser.profileUpdate = false;
            } else {
              this.userRightDisable.ad_profileDisbled = false;
            }


            //if (rightsObj.beneficiaryAccount == false) {
            //  this.agr_BeneficiaryDisabled = true;
            //  this.userRightDisable.ad_beneficiaryDisabled = true;
            //}
            if (rightsObj.beneficiaryAccount == false) {
              // this.agr_BeneficiaryDisabled = true;
              this.userRightDisable.ad_beneficiaryDisabled = true;
              this.branchObj.userObj.adminUser.beneficiaryAccount = false;
            } else {
              this.userRightDisable.ad_beneficiaryDisabled = false;
            }
            //if (rightsObj.paymentProcess == false) {
            //  this.agr_PaymentDisabled = true;
            //  this.userRightDisable.ad_paymentProcessDisabled = true;
            //}
            if (rightsObj.paymentProcess == false) {
              // this.agr_PaymentDisabled = true;
              this.userRightDisable.ad_paymentProcessDisabled = true;
              this.branchObj.userObj.adminUser.paymentProcess = false;
            } else {
              this.userRightDisable.ad_paymentProcessDisabled = false;
            }
            //if (rightsObj.creditLimit == false) {
            //  this.agr_CreditDisabled = true;
            //  this.userRightDisable.ad_creditLimitDisabled = true;
            //}
            if (rightsObj.creditLimit == false) {
              //  this.agr_CreditDisabled = true;
              this.userRightDisable.ad_creditLimitDisabled = true;
              this.branchObj.userObj.adminUser.creditLimit = false;
            } else {
              this.userRightDisable.ad_creditLimitDisabled = false;
            }
            //if (rightsObj.notifications == false) {
            //  this.agr_NoticationsDisabled = true;
            //  this.userRightDisable.ad_notificationsDisabled = true;
            //}
            if (rightsObj.notifications == false) {
              //  this.agr_NoticationsDisabled = true;
              this.userRightDisable.ad_notificationsDisabled = true;
              this.branchObj.userObj.adminUser.notifications = false;
            } else {
              this.userRightDisable.ad_notificationsDisabled = false;
            }
            //if (rightsObj.revenueManagement == false) {
            //  this.agr_ServiceFeeDisabled = true;
            //  this.userRightDisable.ad_revenueDisabled = true;
            //}
            if (rightsObj.revenueManagement == false) {
              // this.agr_ServiceFeeDisabled = true;
              this.userRightDisable.ad_revenueDisabled = true;
              this.branchObj.userObj.adminUser.revenueManagement = false;
            } else {
              // this.agr_ServiceFeeDisabled = true;
              this.userRightDisable.ad_revenueDisabled = false;
            }
            //if (rightsObj.offlineRequest == false) {
            //  this.agr_OfflineRequestDisabled = true;
            //  this.userRightDisable.ad_offlineRequestDisabled = true;
            //}
            if (rightsObj.offlineRequest == false) {
              //  this.agr_OfflineRequestDisabled = true;
              this.userRightDisable.ad_offlineRequestDisabled = true;
              this.branchObj.userObj.adminUser.offlineRequest = false;
            } else {
              //  this.agr_OfflineRequestDisabled = true;
              this.userRightDisable.ad_offlineRequestDisabled = false;
            }
            //if (rightsObj.offlineSettings == false) {
            //  this.agr_OfflineSettingsDisabled = true;
            //  this.userRightDisable.ad_offlineSettingsDisabled = true;
            //}
            if (rightsObj.offlineSettings == false) {
              // this.agr_OfflineSettingsDisabled = true;
              this.userRightDisable.ad_offlineSettingsDisabled = true;
              this.branchObj.userObj.adminUser.offlineSettings = false;
            } else {
              // this.agr_OfflineSettingsDisabled = true;
              this.userRightDisable.ad_offlineSettingsDisabled = false;
            }
            //if (rightsObj.supplierManagement == false) {
            //  this.agr_SupplierDisabled = true;
            //  this.userRightDisable.ad_supplierManagementDisabled = true;
            //  $("#btnAdminCancel").show();
            //  $("#btnAdminSave").html("Save");
            //}
            //else {
            //  //this.supplierStep = true;
            //  $("#btnAdminCancel").hide();
            //  $("#btnAdminSave").html("Next Step");

            //}
            if (rightsObj.supplierManagement == false) {
              // this.supplierStep = false;
              // this.agr_SupplierDisabled = true;
              this.userRightDisable.ad_supplierManagementDisabled = true;
              this.branchObj.userObj.adminUser.supplierManagement = false;
              //  $("#btnAdminCancel").show();
              //  $("#btnAdminSave").html("Save");
            }
            else {
              // this.supplierStep = true;
              //   $("#btnAdminCancel").hide();
              //   $("#btnAdminSave").html("Next Step");

            }

            //if (rightsObj.accountManagement == false) {
            //  this.agr_AccountManagementDisabled = true;
            //  this.userRightDisable.ad_accountManagementDisabled = true;
            //}
            if (rightsObj.accountManagement == false) {
              //  this.agr_AccountManagementDisabled = true;
              this.userRightDisable.ad_accountManagementDisabled = true;
              this.branchObj.userObj.adminUser.accountManagement = false;
            } else {
              //  this.agr_AccountManagementDisabled = true;
              this.userRightDisable.ad_accountManagementDisabled = false;
            }
            //if (rightsObj.bookings == false) {
            //  this.agr_BookingsDisabled = true;
            //  this.userRightDisable.ad_bookingsDisabled = true;
            //}
            if (rightsObj.bookings == false) {
              //  this.agr_BookingsDisabled = true;
              this.userRightDisable.ad_bookingsDisabled = true;
              this.branchObj.userObj.adminUser.bookings = false;
            } else {
              //  this.agr_BookingsDisabled = true;
              this.userRightDisable.ad_bookingsDisabled = false;
            }
            //if (rightsObj.cms == false) {
            //  this.agr_CmsDisabled = true;
            //  this.userRightDisable.ad_cmsDisabled = true;
            //}
            if (rightsObj.cms == false) {
              //  this.agr_CmsDisabled = true;
              this.userRightDisable.ad_cmsDisabled = true;
              this.branchObj.userObj.adminUser.cms = false;
            } else {
              //  this.agr_CmsDisabled = true;
              this.userRightDisable.ad_cmsDisabled = false;
            }
            //if (rightsObj.reports == false) {
            //  this.agr_ReportsDisabled = true;
            //  this.userRightDisable.ad_reportsDisabled = true;
            //}
            if (rightsObj.reports == false) {
              //  this.agr_ReportsDisabled = true;
              this.userRightDisable.ad_reportsDisabled = true;
              this.branchObj.userObj.adminUser.reports = false;
            } else {
              //  this.agr_ReportsDisabled = true;
              this.userRightDisable.ad_reportsDisabled = false;
            }
            //if (rightsObj.dashboard == false) {
            //  this.agr_DashboardDisabled = true;
            //  this.userRightDisable.ad_dashboardDisabled = true;
            //}
            if (rightsObj.dashboard == false) {
              //  this.agr_DashboardDisabled = true;
              this.userRightDisable.ad_dashboardDisabled = true;
              this.branchObj.userObj.adminUser.dashboard = false;
            } else {
              //  this.agr_DashboardDisabled = true;
              this.userRightDisable.ad_dashboardDisabled = false;
            }
            //if (rightsObj.addPayment == false) {
            //  this.agr_AddPaymentDisabled = true;
            //  this.userRightDisable.ad_addPaymentDisabled = true;
            //}
            if (rightsObj.addPayment == false) {
              //  this.agr_AddPaymentDisabled = true;
              this.userRightDisable.ad_addPaymentDisabled = true;
              this.branchObj.userObj.adminUser.addPayment = false;
            } else {
              //  this.agr_AddPaymentDisabled = true;
              this.userRightDisable.ad_addPaymentDisabled = false;
            }
            //if (rightsObj.approvePayment == false) {
            //  this.agr_ApprovePaymentDisabled = true;
            //  this.userRightDisable.ad_approvePaymentDisabled = true;
            //}
            if (rightsObj.approvePayment == false) {
              //  this.agr_ApprovePaymentDisabled = true;
              this.userRightDisable.ad_approvePaymentDisabled = true;
              this.branchObj.userObj.adminUser.approvePayment = false;
            } else {
              //  this.agr_ApprovePaymentDisabled = true;
              this.userRightDisable.ad_approvePaymentDisabled = false;
            }
            //if (rightsObj.deletePayment == false) {
            //  this.agr_DeletePaymentDisabled = true;
            //  this.userRightDisable.ad_deletePaymentDisabled = true;
            //}
            if (rightsObj.deletePayment == false) {
              //  this.agr_DeletePaymentDisabled = true;
              this.userRightDisable.ad_deletePaymentDisabled = true;
              this.branchObj.userObj.adminUser.deletePayment = false;
            } else {
              //  this.agr_DeletePaymentDisabled = true;
              this.userRightDisable.ad_deletePaymentDisabled = false;
            }
            //if (rightsObj.account == false) {
            //  this.agr_AccountDisabled = true;
            //  this.userRightDisable.ad_accountDisabled = true;
            //}
            if (rightsObj.account == false) {
              //  this.agr_AccountDisabled = true;
              this.userRightDisable.ad_accountDisabled = true;
              this.branchObj.userObj.adminUser.account = false;
            } else {
              //  this.agr_AccountDisabled = true;
              this.userRightDisable.ad_accountDisabled = false;
            }

            //if (rightsObj.users == false) {
            //  this.agr_UsersDisabled = true;
            //  this.userRightDisable.ad_usersDisabled = true;
            //}
            if (rightsObj.users == false) {
              //   this.agr_UsersDisabled = true;
              this.userRightDisable.ad_usersDisabled = true;
              this.branchObj.userObj.adminUser.users = false;
            } else {
              //   this.agr_UsersDisabled = true;
              this.userRightDisable.ad_usersDisabled = false;
            }
            //if (rightsObj.logs == false) {
            //  this.agr_LogsDisabled = true;
            //  this.userRightDisable.ad_logsDisabled = true;
            //}
            if (rightsObj.logs == false) {
              //   this.agr_LogsDisabled = true;
              this.userRightDisable.ad_logsDisabled = true;
              this.branchObj.userObj.adminUser.logs = false;
            } else {
              //   this.agr_LogsDisabled = true;
              this.userRightDisable.ad_logsDisabled = false;
            }
            //if (rightsObj.currency == false) {
            //  this.agr_CurrencyDisabled = true;
            //  this.userRightDisable.ad_currencyDisabled = true;
            //}
            if (rightsObj.currency == false) {
              //  this.agr_CurrencyDisabled = true;
              this.userRightDisable.ad_currencyDisabled = true;
              this.branchObj.userObj.adminUser.currency = false;
            } else {
              //  this.agr_CurrencyDisabled = true;
              this.userRightDisable.ad_currencyDisabled = false;
            }

            //if (rightsObj.searchBookings == false) {
            //  this.agr_SearchBookingsDisabled = true;
            //  this.userRightDisable.ad_searchBookingsDisabled = true;
            //}
            if (rightsObj.searchBookings == false) {
              //  this.agr_SearchBookingsDisabled = true;
              this.userRightDisable.ad_searchBookingsDisabled = true;
              this.branchObj.userObj.adminUser.searchBookings = false;
            } else {
              //  this.agr_SearchBookingsDisabled = true;
              this.userRightDisable.ad_searchBookingsDisabled = false;
            }
            //if (rightsObj.viewBookings == false) {
            //  this.agr_ViewBookingsDisabled = true;
            //  this.userRightDisable.ad_viewBookingsDisabled = true;
            //}
            if (rightsObj.viewBookings == false) {
              //  this.agr_ViewBookingsDisabled = true;
              this.userRightDisable.ad_viewBookingsDisabled = true;
              this.branchObj.userObj.adminUser.viewBookings = false;
            } else {
              //  this.agr_ViewBookingsDisabled = true;
              this.userRightDisable.ad_viewBookingsDisabled = false;
            }
            //if (rightsObj.updateBookings == false) {
            //  this.agr_UpdateBookingsDisabled = true;
            //  this.userRightDisable.ad_updateBookingsDisabled = true;
            //}
            if (rightsObj.updateBookings == false) {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ad_updateBookingsDisabled = true;
              this.branchObj.userObj.adminUser.updateBookings = false;
            } else {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ad_updateBookingsDisabled = false;
            }


            if (rightsObj.offlineBooking == false) {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineBookingsDisabled = true;
              this.branchObj.userObj.adminUser.offlineBooking = false;
            } else {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineBookingsDisabled = false;
            }

            if (rightsObj.offlineTicket == false) {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineTicketDisabled = true;
              this.branchObj.userObj.adminUser.offlineTicket = false;
            } else {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineTicketDisabled = false;
            }

            if (rightsObj.offlineVoid == false) {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineVoidDisabled = true;
              this.branchObj.userObj.adminUser.offlineVoid = false;
            } else {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineVoidDisabled = false;
            }

            if (rightsObj.offlineRefund == false) {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineRefundDisabled = true;
              this.branchObj.userObj.adminUser.offlineRefund = false;
            } else {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineRefundDisabled = false;
            }

            if (rightsObj.offlineDealsByCMS == false) {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineDealsDisabled = true;
              this.branchObj.userObj.adminUser.offlineDealsByCMS = false;
            } else {
              //  this.agr_UpdateBookingsDisabled = true;
              this.userRightDisable.ag_offlineDealsDisabled = false;
            }
          }

        })
      }
    }
    catch (e) { }
  }
  loginCheck: boolean;
  CheckLoginName() {
    if (this.branchObj.userObj.loginName != "" && this.branchObj.userObj.loginName != null && this.branchObj.userObj.loginName != undefined) {
      this.branchService.GetCheckLoginNameAvaliability(this.branchObj.userObj.loginName).subscribe((data) => {
        if (data == false) {
          this.loginCheck = true;
        }
        else if (data == true) {
          document.getElementById("loginnamemessage").innerHTML = "Login Name already exsist choose another one";
          setTimeout(function () {
            document.getElementById("loginnamemessage").innerHTML = "";
          }
            , 6000);
          this.loginCheck = false;
        }

      });
    }
    return this.loginCheck;

  }
  ChangeGetSelectedBackSystemCustomers(companyId: number) {
    if (this.branchObj.userObj.backSystemCompanyId != 0) {
      this.custCode.handleClearClick();
    }
    this.GetSelectedBackSystemCustomers(companyId);
  }
  GetSelectedBackSystemCustomers(companyId: number) {
    if (companyId != null && companyId != undefined && companyId > 0) {
      let companyURL = "";
      for (let i = 0; i < this.backSystemCompanies.length; i++) {
        if (companyId == this.backSystemCompanies[i].companyId) {
          companyURL = this.backSystemCompanies[i].companyURL;
          this.loaderVar = true;
          break;
        }

      }
      var req = new UrlRequest();
      req.request = companyURL;
      this.branchService.GetCustomerCodeByID(req).subscribe((data) => {
        this.codes = data;
        this.loaderVar = false;
        this.onChnageCode = [];
        this.backSystemAllList
        for (let i = 0; i < this.backSystemAllList.length; i++) {
          if (this.backSystemAllList[i].backSystemCompanyId == companyId) {
            for (let j = 0; j < this.backSystemAllList[i].backSystemAll.length; j++) {
              for (let k = 0; this.codes.length; k++) {
                if (this.backSystemAllList[i].backSystemAll[j].backSystemCompanyCustomer == this.codes[k].customerCode) {
                  this.onChnageCode.push(this.codes[k]);
                  break;
                }
              }
            }
            break;
          }
        }
      });
    }

  }


  userLimit() {
    if (this.branchObj.immediateParent == "" || this.branchObj.immediateParent == undefined || this.branchObj.immediateParent == null) {
      this.immediateParentForuser = this.branchObj.agencyId;
    }
    this.branchService.UserLimitCheck(this.branchObj.branchId, this.immediateParentForuser, this.branchObj.maxUsers).subscribe(data => {
      //console.log(data)
      if (data == false) {
        this.userlimitreached = true;
        document.getElementById("tbMaxUsers").classList.add("newRequired-BoxColor");
        document.getElementById("labelmaxuser").style.color = "red";
        document.getElementById("requiredusermax").innerHTML = "Maximum Limit Reached"
        document.getElementById("branchInfoClick").setAttribute('disabled', 'disabled');
      }
      else {
        this.userlimitreached = false;
        document.getElementById("tbMaxUsers").classList.remove("newRequired-BoxColor");
        document.getElementById("labelmaxuser").style.color = "";
        document.getElementById("requiredusermax").innerHTML = "";
        document.getElementById("branchInfoClick").removeAttribute('disabled');
      }
    })

  }
  beneficiaryAccountCheckboxChange(e) {
    if (e.target.checked == false) {
      //this.branchObj.agencyRightObj.paymentProcess = false;
      //this.branchObj.agencyRightObj.addPayment=false;
      this.branchObj.agencyRightObj.approvePayment = false;
      //this.branchObj.userObj.adminUser.paymentProcess=false;
      //this.branchObj.userObj.adminUser.addPayment=false;
      this.branchObj.userObj.adminUser.approvePayment = false;
    }
  }
  PaymentProcessCheckboxChange(e) {
    if (e.target.checked == false) {
      this.branchObj.agencyRightObj.paymentProcess = false;
      this.branchObj.agencyRightObj.addPayment = false;
      this.branchObj.agencyRightObj.approvePayment = false;
      this.branchObj.userObj.adminUser.paymentProcess = false;
      this.branchObj.userObj.adminUser.addPayment = false;
      this.branchObj.userObj.adminUser.approvePayment = false;
    }
  }
  PaymentProcessAdminCheckboxChange(e) {
    if (e.target.checked == false) {
      this.branchObj.userObj.adminUser.paymentProcess = false;
      this.branchObj.userObj.adminUser.addPayment = false;
      this.branchObj.userObj.adminUser.approvePayment = false;
    }
  }
  CreditLimitCheckboxChange(e) {
    if (e.target.checked == false) {
      this.branchObj.agencyRightObj.creditLimit = false;
      this.branchObj.userObj.adminUser.creditLimit = false;
    }
  }
  RevenueManagementCheckboxChange(e) {
    if (e.target.checked == false) {
      this.branchObj.agencyRightObj.revenueManagement = false;
      this.branchObj.userObj.adminUser.revenueManagement = false;
    }
  }

  offlineRequestCheckboxChange(e) {
    if (e.target.checked == false) {
      this.branchObj.agencyRightObj.offlineRequest = false;
      this.branchObj.agencyRightObj.offlineBooking = false;
      this.branchObj.agencyRightObj.offlineTicket = false;
      this.branchObj.agencyRightObj.offlineVoid = false;
      this.branchObj.agencyRightObj.offlineRefund = false;
      this.branchObj.agencyRightObj.offlineDealsByCMS = false;

      this.branchObj.userObj.adminUser.offlineRequest = false;
      this.branchObj.userObj.adminUser.offlineBooking = false;
      this.branchObj.userObj.adminUser.offlineTicket = false;
      this.branchObj.userObj.adminUser.offlineVoid = false;
      this.branchObj.userObj.adminUser.offlineRefund = false;
      this.branchObj.userObj.adminUser.offlineDealsByCMS = false;
    }
  }
  offlineRequestAdminCheckboxChange(e) {
    if (e.target.checked == false) {
      this.branchObj.userObj.adminUser.offlineRequest = false;
      this.branchObj.userObj.adminUser.offlineBooking = false;
      this.branchObj.userObj.adminUser.offlineTicket = false;
      this.branchObj.userObj.adminUser.offlineVoid = false;
      this.branchObj.userObj.adminUser.offlineRefund = false;
      this.branchObj.userObj.adminUser.offlineDealsByCMS = false;
    }
  }
  offlineSettingsCheckboxChange(e) {
    if (e.target.checked == false) {
      this.branchObj.agencyRightObj.offlineSettings = false;
      this.branchObj.userObj.adminUser.offlineSettings = false;
    }
  }
  supplierManagementCheckboxChange(e) {
    if (e.target.checked == false) {
      this.branchObj.agencyRightObj.supplierManagement = false;
      this.branchObj.userObj.adminUser.supplierManagement = false;
    }
  }
  accountManagementCheckboxChange(e) {
    if (e.target.checked == false) {
      this.branchObj.agencyRightObj.accountManagement = false;
      this.branchObj.agencyRightObj.users = false;
      this.branchObj.agencyRightObj.account = false;
      this.branchObj.agencyRightObj.agencyManagement = false;
      this.branchObj.agencyRightObj.branchManagement = false;

      this.branchObj.userObj.adminUser.accountManagement = false;
      this.branchObj.userObj.adminUser.users = false;
      this.branchObj.userObj.adminUser.account = false;
      this.branchObj.userObj.adminUser.agencyManagement = false;
      this.branchObj.userObj.adminUser.branchManagement = false;

    }
  }
  accountManagementAdminCheckboxChange(e) {
    if (e.target.checked == false) {

      this.branchObj.userObj.adminUser.accountManagement = false;
      this.branchObj.userObj.adminUser.users = false;
      this.branchObj.userObj.adminUser.account = false;
      this.branchObj.userObj.adminUser.agencyManagement = false;
      this.branchObj.userObj.adminUser.branchManagement = false;

    }
  }
  BookingsCheckboxChange(e) {
    if (e.target.checked == false) {
      this.branchObj.agencyRightObj.searchBookings = false;
      this.branchObj.agencyRightObj.viewBookings = false;
      this.branchObj.agencyRightObj.viewSubAgentBookings = false;
      this.branchObj.agencyRightObj.issueTicket = false;
      this.branchObj.agencyRightObj.cancelPNR = false;
      this.branchObj.agencyRightObj.refund = false;
      this.branchObj.agencyRightObj.importPNR = false;
      this.branchObj.agencyRightObj.exchange = false;
      this.branchObj.agencyRightObj.quotations = false;
      this.branchObj.agencyRightObj.fareRulesResult = false;
      this.branchObj.agencyRightObj.voidTicket = false;

      this.branchObj.userObj.adminUser.searchBookings = false;
      this.branchObj.userObj.adminUser.viewBookings = false;
      this.branchObj.userObj.adminUser.viewSubAgentBookings = false;
      this.branchObj.userObj.adminUser.issueTicket = false;
      this.branchObj.userObj.adminUser.cancelPNR = false;
      this.branchObj.userObj.adminUser.refund = false;
      this.branchObj.userObj.adminUser.exchangeTicket = false;
      this.branchObj.userObj.adminUser.importPNR = false;
      this.branchObj.userObj.adminUser.quotations = false;
      this.branchObj.userObj.adminUser.fareRules = false;
      this.branchObj.userObj.adminUser.voidTicket = false;

      this.branchObj.userObj.adminUser.modifyBooking = false;
      this.branchObj.agencyRightObj.modifyBooking = false;


    }
  }
  BookingsAdminCheckboxChange(e) {
    if (e.target.checked == false) {
      this.branchObj.userObj.adminUser.searchBookings = false;
      this.branchObj.userObj.adminUser.viewBookings = false;
      this.branchObj.userObj.adminUser.viewSubAgentBookings = false;
      this.branchObj.userObj.adminUser.issueTicket = false;
      this.branchObj.userObj.adminUser.cancelPNR = false;
      this.branchObj.userObj.adminUser.refund = false;
      this.branchObj.userObj.adminUser.exchangeTicket = false;
      this.branchObj.userObj.adminUser.importPNR = false;
      this.branchObj.userObj.adminUser.quotations = false;
      this.branchObj.userObj.adminUser.fareRules = false;
      this.branchObj.userObj.adminUser.voidTicket = false;
      this.branchObj.userObj.adminUser.modifyBooking = false;


    }
  }
  OnAgencyBranchChildChange() {

    if (this.branchObj.maximumChildBranches < 0) {
      this.branchObj.maximumChildBranches = 0;
    }
  }
  supplierRightsClickTab() {
    this.GetparentAgencyRights();
    this.GetSuppliersByParent();
  }
  AgencyRightsClickTab() {
    for (let k = 0; k < this.reportTypesAgency.length; k++) {
      for (let j = 0; j < this.reportTypesUser.length; j++) {
        if (this.reportTypesUser[j].reportTypes == this.reportTypesAgency[k].reportTypes) {
          this.reportTypesUser[j].statusForUser = this.reportTypesAgency[k].status;
          this.reportTypesUser[j].status = this.reportTypesAgency[k].status;
        }
      }
    }

    this.GetparentAgencyRights();
    this.adminrightifagencynot();


  }
  goToStep(stepNumber: number): void {

    let checkingValueString: boolean = false;
    if (this.agencylistid != null && this.agencylistid != "" && this.agencylistid != undefined) {
      checkingValueString = true;
    }
    else {
      checkingValueString = false;
    }


    if (checkingValueString) {
      this.branchInfoComplete = false;
      this.BackOfficeInfoComplete = false;
      this.managerInfoComplete = false;
      this.adminInfoComplete = false;
      this.settleModeComplete = false;
      this.logoInfoComplete = false;
      this.agencyRightsComplete = false;
      this.supplierRightsComplete = false;


      switch (stepNumber) {
        case 1:
          this.branchInfoComplete = true;
          this.stepOne = true;
          this.stepTwo = false;
          this.stepThree = false;
          this.stepFour = false;
          this.stepFive = false;
          this.stepSix = false;
          break;
        case 2:
          this.BackOfficeInfoComplete = true;
          this.backsystemOfficeProperties = [];
          if (this.branchObj.branchId.includes("AG01")) {
            this.selectMultipleBackSystemCustomer = true;
          }
          else {
            this.selectMultipleBackSystemCustomer = false;
          }
          this.currencyCodeList$.subscribe(data => {
            const currencyList = data.find(id => id.currencyId === this.branchObj.currencyId);
            const comapnyList = this.backSystemCompanies.filter(company =>
              currencyList.currencyName.includes(company.companyCurrency));
            this.backSystemCompanies = comapnyList;

          });
          this.backsystemgetinfo(this.branchObj.branchId);
          this.stepOne = true;
          this.stepTwo = true;
          this.stepThree = false;
          this.stepFour = false;
          this.stepFive = false;
          this.stepSix = false;
          break;
        case 3:
          this.agencyRightsComplete = true;
          this.branchService.AgencyBranchLimitationRights(this.branchObj.branchId).subscribe((data) => {
            this.AgencyBranchLimitationRights = data;
          });
          this.stepOne = true;
          this.stepTwo = true;
          this.stepThree = true;
          this.stepFour = false;
          this.stepFive = false;
          this.stepSix = false;
          break;
        case 4:
          this.adminInfoComplete = true;
          this.branchService.AgencyBranchLimitationRights(this.branchObj.branchId).subscribe((data) => {
            this.AgencyBranchLimitationRights = data;
          });
          this.AgencyRightsClickTab();
          if (this.branchObj.immediateParent != "AG01") {
            this.backsystemgetinfo(this.branchObj.immediateParent);
          }
          else {

            this.backsystemgetinfo(this.branchObj.branchId);
          }
          this.stepOne = true;
          this.stepTwo = true;
          this.stepThree = true;
          this.stepFour = true;
          this.stepFive = false;
          this.stepSix = false;
          break;
        case 5:
          this.managerInfoComplete = true;
          this.reportTypesUser[0].requestStatus = false;
          this.GetUsers();
          this.GetParentManagers(this.branchObj.immediateParent, this.branchObj.branchId);
          this.stepOne = true;
          this.stepTwo = true;
          this.stepThree = true;
          this.stepFour = true;
          this.stepFive = true;
          this.stepSix = false;
          break;
        case 6:
          this.supplierRightsComplete = true;
          this.supplierRightsClickTab();
          this.stepSix = true;
          this.stepOne = true;
          this.stepTwo = true;
          this.stepThree = true;
          this.stepFour = true;
          this.stepFive = true;
          break;

      }
    }
  }
  AddNewSupplierOfficeId(index: number) {
    if (this.agencySuppliers[index].supplierBoolean.length < this.agencySuppliers[index].supplierOfficeIdsCounter) {
      let supplierBool = new SupplierRightsForAgencyAndBranchBooleanProperties();
      this.agencySuppliers[index].supplierBoolean.push(supplierBool);

    }
    else {
      document.getElementById(`suppliers_Add-Error${index}`).innerHTML = "You Can't Add More Suppliers";
      setTimeout(() => {
        document.getElementById(`suppliers_Add-Error${index}`).innerHTML = "";
      }, 5000);

    }

  }
  RemoveSupplierOfficeId(index: number, JIndex: number) {
    this.agencySuppliers[index].supplierBoolean.splice(JIndex, 1)

  }
  //10-June-24

  GroupTicketRightCheckManage=(event:any):void=>{
    if(event.target.checked==false){
      this.branchObj.agencyRightObj.groupTicketRight=false;
      this.branchObj.agencyRightObj.groupTicketListRight=false;
      this.branchObj.agencyRightObj.groupTicketCreateRight=false;
      this.branchObj.agencyRightObj.groupTicketShowRight=false;
      this.branchObj.userObj.adminUser.groupTicketRight=false;
      this.branchObj.userObj.adminUser.groupTicketListRight=false;
      this.branchObj.userObj.adminUser.groupTicketCreateRight=false;
      this.branchObj.userObj.adminUser.groupTicketShowRight=false;
    }
  }
  GroupTicketAdminRightCheckManage=(event:any):void=>{
    if(event.target.checked==false){
      this.branchObj.userObj.adminUser.groupTicketRight=false;
      this.branchObj.userObj.adminUser.groupTicketListRight=false;
      this.branchObj.userObj.adminUser.groupTicketCreateRight=false;
      this.branchObj.userObj.adminUser.groupTicketShowRight=false;
    }
  }
  //end
  adminInfoClick = (req: string): boolean => {
    try {

      //this.CheckAdminValidations();
      if (this.CheckAdminValidations()) {
        this.branchObj.userObj.password = this.branchObj.userObj.password ? this.branchObj.userObj.password : "";
        if (this.branchObj.userObj.isBranchAdmin == false) {
          this.branchObj.userObj.adminUser = new UserAdminControlRightsProperties();
        }
        else {
          if (this.branchObj.userObj.adminUser.paymentProcess == false) {
            this.branchObj.userObj.adminUser.addPayment = false;
            this.branchObj.userObj.adminUser.approvePayment = false;
            this.branchObj.userObj.adminUser.deletePayment = false;
          }
          if (this.branchObj.userObj.adminUser.accountManagement == false) {
            this.branchObj.userObj.adminUser.account = false;
            this.branchObj.userObj.adminUser.users = false;
            this.branchObj.userObj.adminUser.logs = false;
            this.branchObj.userObj.adminUser.currency = false;
          }
          if (this.branchObj.userObj.adminUser.bookings == false) {
            this.branchObj.userObj.adminUser.searchBookings = false;
            this.branchObj.userObj.adminUser.viewBookings = false;
            this.branchObj.userObj.adminUser.updateBookings = false;
          }
        }

        if (this.branchObj.userObj.isAgent == false) {
          this.branchObj.userObj.agentUser = new UserAgentRightsProperties();
        }
        else {
          if (this.branchObj.userObj.agentUser.book == false) {
            this.branchObj.userObj.agentUser.newBookings = false;
            this.branchObj.userObj.agentUser.myBookings = false;
            this.branchObj.userObj.agentUser.searchBookings = false;
          }
        }


        let param = "";
        let isAgency;
        let userId = 0;
        if (localStorage.getItem("UserId") != undefined && localStorage.getItem("UserId") != null) {
          userId = Number(localStorage.getItem("UserId"))
          if (userId != 0) {
            if (this.branchObj.branchId != "" && this.branchObj.branchId != undefined) {

              this.branchObj.userObj.agency_branchId = this.branchObj.branchId;
              if (this.branchObj.userObj.userId == 0 || this.branchObj.userObj.userId == null ||
                this.branchObj.userObj.userId == undefined) {
                isAgency = false;
                param = this.branchObj.branchId;
                this.branchService.CheckUsersLimit(param, isAgency).subscribe((data) => {
                  if (data != null && data != undefined) {
                    if (data == -1) {
                      $("#lblerrormsg").show();
                      document.getElementById("lblerrormsg").innerHTML = "Maximum User Limit Reached."
                      $("#lblerrormsg").delay(5000).hide(10);
                    }
                    else {
                      //01-feb-24
                      if (this.CheckUserEmail() == true) {
                        return false;
                      }
                      //end
                      if (this.CheckLoginName() == false) {
                        return false;
                      }
                      this.branchObj.userObj.creationUser = userId;
                      this.branchObj.userObj.branchId = "";
                      this.reportTypesUser[0].requestStatus = true;
                      this.branchObj.userObj.reportTypesRightsUser = this.reportTypesUser;
                      this.branchService.CreateAdminUser(this.branchObj.userObj).subscribe((data) => {
                        if (data != 0 && data != null) {
                          this.branchObj.userObj.userId = data;
                          this.reportTypesUser[0].requestStatus = false;
                          this.adminInfoComplete = false;
                          this.managerInfoComplete = true;
                          this.stepFive = true;
                          this.GetUsers();
                          this.GetParentManagers(this.branchObj.immediateParent, this.branchObj.branchId);

                        }
                        else {
                          this.branchObj.userObj.userId = 0;

                          $("#lblerrormsg").show();
                          document.getElementById("lblerrormsg").innerHTML = "Something went wrong."
                          $("#lblerrormsg").delay(5000).hide(10);
                        }
                      });

                    }
                  }
                  else {
                    $("#lblerrormsg").show();
                    document.getElementById("lblerrormsg").innerHTML = "Something went wrong."
                    $("#lblerrormsg").delay(5000).hide(10);
                  }
                });
              }
              else {
                //01-feb-24
                if (this.CheckUserEmail() == true) {
                  return false;
                }
                else {
                  //end
                  this.branchObj.userObj.modifyUser = userId;
                  this.branchObj.userObj.reportTypesRightsUser = this.reportTypesUser;
                  this.reportTypesUser[0].requestStatus = true;
                  this.branchService.UpdateAdminUser(this.branchObj).subscribe((r) => {
                    if (r == true) {
                      this.reportTypesUser[0].requestStatus = false;
                      this.adminInfoComplete = false;
                      this.managerInfoComplete = true;
                      this.stepFive = true;
                      this.GetUsers();
                      this.GetParentManagers(this.branchObj.immediateParent, this.branchObj.branchId);

                    }
                    else {
                      $("#lblerrormsg").show();
                      document.getElementById("lblerrormsg").innerHTML = "Something went wrong."
                      $("#lblerrormsg").delay(5000).hide(10);
                    }
                  });
                }
              }
            }
          }
        }




        if (req === 'save') {
          this.router.navigateByUrl("/flightSearch")
        }
      }

    } catch (e) {
      console.log(e)
    }
  }

  //01-Feb-24 Replace Function
  SelectFileUpload(e) {
    try {
      this.checkImgUpload = false;

      let files = e.target.files;
      if (files.length == 0)
        return;
      else {
        this.disablefileupload = true;
        let response = "";
        let responseSplit;
        let firstResponsePart;
        let secondResponsePart;
        let responseCheck;
        var fileToUpload = files.item(0)
        let reader = new FileReader();
        reader.onload = (event: any) => {
          this.imageSource = event.target.result;
        }
        reader.readAsDataURL(fileToUpload);

        const formData = new FormData();
        for (let file of files) {
          formData.append(file.name, file);
        }
        const uploadReq = new HttpRequest('POST', this.baseUrl + '/AgencyMaster/UploadFile', formData, {
          reportProgress: true,
        });
        this.http.request(uploadReq).subscribe(event => {
          if (event.type === HttpEventType.UploadProgress) {
            this.progress = Math.round(100 * event.loaded / event.total);
          }
          else if (event.type === HttpEventType.Response) {
            response = event.body.toString();
            responseSplit = response.split("\"");
            firstResponsePart = responseSplit[0];
            secondResponsePart = firstResponsePart.split("/,/");
            responseCheck = secondResponsePart[0];
            if (responseCheck == "Uploaded") {
              this.branchObj.logoFileName = secondResponsePart[2];
              this.branchObj.logoFilePath = secondResponsePart[1];
              this.disablefileupload = false;
              this.checkImgUpload = true;
              $("#lbluploadmsg").show();
              document.getElementById("lbluploadmsg").innerHTML = "File Uploaded."
              $("#lbluploadmsg").delay(4000).hide(10);
            }

            else {
              this.disablefileupload = false;
              this.checkImgUpload = false;
              $("#lblerrormsg").show();
              document.getElementById("lblerrormsg").innerHTML = "Failed Upload File. Please Try Later."
              $("#lblerrormsg").delay(5000).hide(10);
              return false;
            }
          }
        });

      }


    }
    catch (e) {
      console.log(e)
    }

  }

  //01-Feb-24 New Function 
  userEmailExist: boolean;
  public CheckUserEmail = (): boolean => {
    if (this.branchObj.userObj.email != "" && this.branchObj.userObj.email != null && this.branchObj.userObj.email != undefined) {
      this.branchService.CheckUserEmailValidation(this.branchObj.userObj.email, this.branchObj.userObj.userId).subscribe((data) => {
        if (data == false) {
          this.userEmailExist = false;
        }
        else {
          document.getElementById("requireduseremail").innerHTML = "Email already exsist choose another one";
          setTimeout(function () {
            document.getElementById("requireduseremail").innerHTML = "";
          }
            , 6000);
          this.userEmailExist = true;
        }
      });

      return this.userEmailExist;
    }


  }
  //end
  AddNewInsuranceSupplierOfficeId(index: number) {

    if (this.insuranceSuppliers[index].supplierBoolean.length < this.insuranceSuppliers[index].supplierOfficeIdsCounter) {
      let supplierBool = new SupplierRightsForAgencyAndBranchBooleanProperties();
      this.insuranceSuppliers[index].supplierBoolean.push(supplierBool);

    }
    else {
      document.getElementById(`suppliers_Add-Error${index}`).innerHTML = "You Can't Add More Suppliers";
      setTimeout(() => {
        document.getElementById(`suppliers_Add-Error${index}`).innerHTML = "";
      }, 5000);

    }

  }
  RemoveInsuranceSupplierOfficeId(index: number, JIndex: number) {
    this.insuranceSuppliers[index].supplierBoolean.splice(JIndex, 1)

  }
  //01-Apr-24
  ChangeApprovePayment = (event: any): void => {
    if (event.target.checked == false) {
      this.branchObj.userObj.adminUser.approvePayment = false;
      this.branchObj.userObj.adminUser.beneficiaryAccount = false;
    }
  }

  InsuranceCheckManage = (event: any): void => {
    if (event.target.checked == false) {
      this.branchObj.agencyRightObj.insuranceRight = false;
      //this.agencyObj.agencyRightObj.insuranceIssuanceRight = false;
      //this.agencyObj.agencyRightObj.insuranceBookedViewRight = false;
      //this.agencyObj.agencyRightObj.insuranceCancelRight = false;
    }
    else if (event.target.checked == true) {
      this.branchObj.agencyRightObj.insuranceRight = true;
      //this.agencyObj.agencyRightObj.insuranceIssuanceRight = true;
      //this.agencyObj.agencyRightObj.insuranceBookedViewRight = true;
      //this.agencyObj.agencyRightObj.insuranceCancelRight = true;
    }
  }
  InsuranceAdminRightCheckManage = (event: any): void => {
    if (event.target.checked == false) {
      this.branchObj.userObj.adminUser.insuranceRight = false;
    }
    else if (event.target.checked == true) {
      this.branchObj.userObj.adminUser.insuranceRight = true;
    }
  }
  //end

}
